import React, { useState, useEffect } from "react";
import { Container, Row, Col, Card, Modal } from "react-bootstrap";
import Select from "react-select";
import { addDays, endOfMonth, addMonths } from "date-fns";
import swal from "sweetalert";
import { AES, enc } from "crypto-js";
import { BASE_URL } from "../CommonApi";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import Alert from "@mui/material/Alert";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";

function BillsUpdate(props) {
  const jwtToken = localStorage.getItem("jwtToken");
  const encryptedUniqueId = localStorage.getItem("uniqueId1");
  const decryptedUniqueId = AES.decrypt(
    encryptedUniqueId,
    "1234567812345678"
  ).toString(enc.Utf8);

  const [row, setRow] = useState([
    {
      itemDetails: "",
      itemCode:"",
      account: "",
      hsnSac: "",
      per:"1",
      quantity: "1",
      rate: "0.0",
      discount: "0.0",
      discountType: "₹",
    },
  ]);

  const [userDetails, setUserDetails] = useState([
    {
      itemDetails: "",
      itemDetails2: "",
      itemCode:"",
      batchId: "",
      hsnSac: "",
      size: "",
      per:"",
      quantity: "",
      rate1: "",
      rate: "",
      discount: "",
      discountType: "%",
      tax: "",
      selectedTaxRate: 0,
      description1: "",
      description2: "",
    },
  ]);

  const [manualCheck, setManualCheck] = useState("No");

  const handleAdd = () => {
    setUserDetails([
      ...userDetails,
      {
        itemDetails: "",
        itemDetails2: "",
        itemCode:"",
        account: "",
        hsnSac: "",
        size: "",
        per:"1",
        quantity: "1",
        rate: "0.0",
        discount: "0.0",
        discountType: "₹",
        tax: "0",
      },
    ]);
  };

  const [oldBillNumber, setOldBillNumber] = useState("");
  const [oldWareHouseName, setOldWareHouseNames] = useState("");
  const [showing1, setShowing1] = useState(false);
  const [showing2, setShowing2] = useState(false);
  const [selectedVendorId, setSelectedVendorId] = useState("");
  const [vendorNames, setVendorNames] = useState([]);
  const [fetchedVendorName, setFetchedVendorName] = useState("");
  const [fetchedDiscountAccount, setfetchedDiscountAccount] = useState("");
  const [fetchedSalesPerson, setFetchedSalesPerson] = useState("");
  const [fetchedPaymentTerms, setFetchedPaymentTerms] = useState("");
  const [showDiscount, setShowDiscount] = useState("");
  const [sizeCheck, setSizeCheck] = useState("");
  const [disAllValue, setDisAllValue] = useState("");
  const [selectedTaxType, setSelectedTaxType] = useState("");
  const [discountAmountTds, setDiscountAmountTds] = useState(0.0);
  const [discountAmountTcs, setDiscountAmountTcs] = useState(0.0);
  const [bussinessRegistered, setBussinessRegistered] = useState("");
  const [dropdownData, setDropdownData] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [searchResults, setSearchResults] = useState([]);
  const [searchPerformed, setSearchPerformed] = useState(false);
  const [deletedItems, setDeletedItems] = useState([]); // State to store deleted items

  const fetchAllVendors = () => {
    fetch(BASE_URL + `/fetchVendors`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${jwtToken}`,
      },
      body: JSON.stringify({ uniqueId: decryptedUniqueId }),
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.status === "success") {
          setVendorNames(data.responseMessage);
        } else {
          console.error("Failed to fetch vendor names:", data.responseMessage);
        }
      })
      .catch((error) => {
        console.error("Error fetching vendor names:", error);
      });
  };
  useEffect(() => {
    fetchAllVendors();
  }, []);

  useEffect(() => {
    fetchAllVendors();
  }, []);

  const handleTdsOptionChange = (selectedOption) => {
    setSelectedTdsOption(selectedOption);
    const subtotal = calculateSubTotal();

    if (selectedOption && selectedOption.discount) {
      const discountedTotal = applyDiscount(subtotal, selectedOption.discount);
      console.log(
        `Subtotal: ${subtotal}, Discounted Total: ${discountedTotal}`
      );
    }
  };

  const handleTcsOptionChange = (selectedOption) => {
    setSelectedTcsOption(selectedOption);
    const subtotal = calculateSubTotal();
    if (selectedOption && selectedOption.discount) {
      const discountedTotal = applyDiscountTcs(
        subtotal,
        selectedOption.discount
      );
      console.log(
        `Subtotal: ${subtotal}, Discounted Total: ${discountedTotal}`
      );
    }
  };

  const applyDiscountTcs = (subtotal, discountPercentage) => {
    const discountAmount = (subtotal * discountPercentage) / 100;
    const tcsDis = (subtotal - discountAmount).toFixed(2);
    setDiscountAmountTcs(parseFloat(discountAmount.toFixed(2))); // Set discountAmount in state

    return tcsDis;
  };

  const applyDiscount = (subtotal, discountPercentage) => {
    const discountAmount = (subtotal * discountPercentage) / 100;
    const tdsDis = (subtotal - discountAmount).toFixed(2);
    setDiscountAmountTds(parseFloat(discountAmount.toFixed(2))); // Set discountAmount in state

    return tdsDis;
  };

  const tds = [
    {
      value: "Commission or Brokerag 5%",
      label: "Commission or Brokerag 5%",
      discount: 5,
    },
    {
      value: "Commission or Brokerag (Reduced) 3.75%",
      label: "Commission or Brokerag (Reduced) 3.75%",
      discount: 3.75,
    },
    { value: "Divident 10%", label: "Divident 10%", discount: 10 },
    {
      value: "Divident (Reduced) 7.5%",
      label: "Divident (Reduced) 7.5%",
      discount: 7.5,
    },
    {
      value: "Other Interest then securities 10%",
      label: "Other Interest then securities 10%",
      discount: 10,
    },
    {
      value: "Other Interest then securities (Reduced) 7.5%",
      label: "Other Interest then securities (Reduced) 7.5%",
      discount: 7.5,
    },
    {
      value: "Payment of Contractors Others 2%",
      label: "Payment of Contractors Others 2%",
      discount: 2,
    },
    {
      value: "Payment of Contractors Others (Reduced) 1.5%",
      label: "Payment of Contractors Others (Reduced) 1.5%",
      discount: 1.5,
    },
    {
      value: "Payment of Contractors Others HUD/Indiv 1%",
      label: "Payment of Contractors Others HUD/Indiv 1%",
      discount: 1,
    },
    {
      value: "Payment of Contractors Others HUD/Indiv (Reduced) 0.75%",
      label: "Payment of Contractors Others HUD/Indiv (Reduced) 0.75%",
      discount: 0.75,
    },
    {
      value: "Professional Fees 10%",
      label: "Professional Fees 10%",
      discount: 10,
    },
    {
      value: "Rent on land or furniture etc 10%",
      label: "Rent on land or furniture etc 10%",
      discount: 10,
    },
  ];

  const tcs = [
    { value: "0 GST [0%]", label: "0 GST [0%]",discount:0 },
    { value: "5 GST [5%]", label: "5 GST [5%]", discount: 5 },
    { value: "12 GST [12%]", label: "12 GST [12%]", discount: 12 },
    { value: "18 GST [18%]", label: "18 GST [18%]", discount: 18 },
    { value: "28 GST [28%]", label: "28 GST [28%]", discount: 28 },
  ];

  const [selectedTdsOption, setSelectedTdsOption] = useState(null); // To store the selected TDS option
  const [selectedTcsOption, setSelectedTcsOption] = useState(null);

  const handleDeleteRow = (i, id) => {
    if (userDetails.length === 1) {
      alert("Cannot delete the last remaining invoice.");
      return;
    }
    const userConfirmed = window.confirm(
      "Are you sure? Once deleted, you will not be able to recover this bills!"
    );

    if (userConfirmed) {
      const deletedRow = userDetails[i];

      const newDeletedRowData = {
        itemName: deletedRow.itemDetails,
        quantity: deletedRow.quantity,
      };
      fetch(BASE_URL + `/deleteBill/${id}`, {
        method: "DELETE",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${jwtToken}`,
        },
      })
        .then((response) => {
          if (response.status === 200) {
            const updatedUserDetails = [...userDetails];
            updatedUserDetails.splice(i, 1);
            setUserDetails(updatedUserDetails);
            setDeletedItems((prevData) => [...prevData, newDeletedRowData]);
          } else {
            const newValidationMessage =
              "The payment entered is more than the total amount due for this invoice. Please check and retry.";
            setValidationMessage1(newValidationMessage);
            window.scrollTo(0, 0);
            console.error("Failed to delete Bills Items");
          }
        })
        .catch((error) => {
          console.error("Error deleting Bills Items:", error);
        });
    } else {
      alert("Bill Items deletion canceled!");
    }
  };

  const handleCancleClick = () => {
    const confirmCancel = window.confirm("Are you sure Leave this page?");
    if (confirmCancel) {
      props.handleCancel();
    } else {
      console.log("Cancellation not confirmed");
    }
  };

  const calculateAmount = (data, tax) => {
    const { quantity, rate, discount, discountType } = data;
    let amount = quantity * rate;
    if (discount) {
      amount -= discountType === "%" ? (amount * discount) / 100 : discount;
    }

    return amount;
  };

  const calculateTAX = (data) => {
    const { tax } = data;
    let totalTAX = 0;
    if (tax > 0) {
      const amount = calculateAmount(data);
      const increasedTaxAmount = (parseFloat(amount) * tax) / 100;
      totalTAX = increasedTaxAmount;
    }
    return totalTAX.toFixed(2);
  };

  const calculateSubTotal = () => {
    let subTotal = 0;
    userDetails.forEach((data) => {
      const amount = calculateAmount(data);
      subTotal += parseFloat(amount);
    });
    return subTotal.toFixed(2);
  };

  useEffect(() => {
    setSubTotal(calculateSubTotal(userDetails));
  }, [userDetails]);

  const calculateIGST = () => {
    let totalIGST = 0;

    userDetails.forEach((data) => {
      const taxRate = parseFloat(data.tax || 0);
      if (taxRate > 0) {
        const amount = calculateAmount(data, taxRate);
        const increasedTaxAmount = (parseFloat(amount) * taxRate) / 100;
        totalIGST += increasedTaxAmount;
      }
    });

    return totalIGST.toFixed(2);
  };

  const calculateIGSTForTax = () => {
    const taxResults = [];

    userDetails.forEach((data) => {
      const taxRate = parseFloat(data.tax / 100 || 0);
      if (taxRate > 0) {
        let existingTaxResult = taxResults.find(
          (result) => result.taxRate === taxRate
        );
        if (!existingTaxResult) {
          existingTaxResult = { taxRate, totalIGST: 0 };
          taxResults.push(existingTaxResult);
        }
        const amount = calculateAmount(data, taxRate);
        const increasedTaxAmount = amount * taxRate;
        existingTaxResult.totalIGST += increasedTaxAmount;
      }
    });
    return taxResults;
  };

  const calculateSGSTandCGST = () => {
    let totalSGST = 0;
    let totalCGST = 0;

    userDetails.forEach((data) => {
      const taxRate = parseFloat(data.tax || 0);
      const amount = calculateAmount(data, taxRate);
      const increasedTaxAmount = (parseFloat(amount) * taxRate) / 100;
      const sgst = increasedTaxAmount / 2;
      const cgst = increasedTaxAmount / 2;
      totalSGST += sgst;
      totalCGST += cgst;
    });
    return {
      totalSGST: totalSGST.toFixed(2),
      totalCGST: totalCGST.toFixed(2),
    };
  };

  const calculateGroupedSGSTandCGST = () => {
    const taxGroups = userDetails.reduce((acc, data) => {
      const taxRate = parseFloat(data.tax / 100 || 0);
      if (taxRate === 0) return acc; // Skip 0% GST

      const amount = calculateAmount(data, taxRate);
      const increasedTaxAmount = amount * taxRate;
      const sgst = increasedTaxAmount / 2;
      const cgst = increasedTaxAmount / 2;

      if (!acc[taxRate]) {
        acc[taxRate] = { totalSGST: 0, totalCGST: 0 };
      }

      acc[taxRate].totalSGST += sgst;
      acc[taxRate].totalCGST += cgst;

      return acc;
    }, {});

    return taxGroups;
  };

  const handleTermsAndConditionChange = (value) => {
    setFormData((prevFormData) => ({
      ...prevFormData,
      termsAndCondition: value,
    }));
  };

  const [currentDate, setCurrentDate] = useState(
    new Date().toISOString().substring(0, 10)
  );

  const [salesPersonData, setSalesPersonData] = useState([]);
  const [selectedVendor, setSelectedVendor] = useState("");

  const [selectedTaxRate, setSelectedTaxRate] = useState(0);
  const [selectedTerms, setSelectedTerms] = useState("");
  const [dueDate, setDueDate] = useState(null);
  const [dueDateChangedManually, setDueDateChangedManually] = useState(false);
  const [showDueDate, setShowDueDate] = useState(true);
  const [showDuePerTerm, setShowDuePerTerm] = useState(false);
  const [selectedDiscountAccount, setSelectedDiscountAccount] = useState(null);

  const [ids, setIds] = useState([]);

  const itemDetails = row.map((data) => {
    return {
      itemDetails: data.itemDetails || "",
      account: data.account || "Default Account", // Set a default value if account is undefined
      per:data.per || "",
      quantity: data.quantity || "",
      rate: data.rate || "",
      discount: data.discount || "",
      discountType: data.discountType || "",
      tax: selectedTaxRate, // Assuming the tax rate is the same for all items
      amount: calculateAmount(data, selectedTaxRate),
    };
  });

  const [formData, setFormData] = useState({
    orderNumber: "",
    billsNumber: "",
    billsDate: "",
    vendorId: "",
    terms: "",
    dueDate: "",
    salesPerson: "",
    items: itemDetails,
    subject: "",
    quantity: "",
    customerDetails: "",
    amount: "",
    subtotal: "",
    adjustment: "",
    adjustmentLabel: "",
    total: "",
    customerNote: "",
    termsAndCondition: "",
    taxType: "",
    tcsTax: "",
    tdsTax: "",
    discountAmount: "",
    value: "",
  });

  const handleRadioClick = (taxType, value) => {
    setSelectedTaxType(taxType);
    setFormData({ ...formData, type: taxType });

    if (taxType === "TDS") {
      setSelectedTcsOption(null);
      setDiscountAmountTds(0);
      setDiscountAmountTcs(0);
      setTType("TDS");
    } else if (taxType === "TCS") {
      setSelectedTdsOption(null);
      setDiscountAmountTcs(0);
      setDiscountAmountTds(0);
      setTType("TCS");
    }

    // Toggle the show/hide state
    setShowing1(taxType === "TDS");
    setShowing2(taxType === "TCS");
  };

  useEffect(() => {
    setSelectedTdsOption(formData.tdsTax);
  }, [formData.tdsTax]);

  useEffect(() => {
    setSelectedTcsOption(formData.tcsTax);
  }, [formData.tcsTax]);

  useEffect(() => {
    setSelectedTerms(formData.terms);
  }, [formData.terms]);

  const { billsNumber } = props;
  const [validationMessage1, setValidationMessage1] = useState("");
  const [tType, setTType] = useState("");
  const totalTax =
    calculateIGST() ||
    calculateSGSTandCGST().totalSGST + calculateSGSTandCGST().totalCGST;

  const [subTotal, setSubTotal] = useState(calculateSubTotal(userDetails));
  const [isLoading, setIsLoading] = useState(false);
  const [isLoading2, setIsLoading2] = useState(false);
  const [userState, setUserState] = useState([]);
  const [customerState, setCustomerState] = useState("");
  const [columnCheck, setColumnCheck] = useState("");
  const userId = localStorage.getItem("userId");
  const apiUrl = BASE_URL + `/fetchUserProfile`;
  const fetchData = () => {
    fetch(apiUrl, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${jwtToken}`,
      },
      body: JSON.stringify({ uniqueId: decryptedUniqueId, userId: userId }),
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.status === "success") {
          const userState = data.responseMessage;
          setUserState(userState);
        } else {
          console.error("Error fetching portfolio data");
        }
      })
      .catch((error) => {
        console.error("Error fetching portfolio data:", error);
      });
  };

  useEffect(() => {
    fetchData();
  }, []);

  const insertDataIntoDatabase = async () => {
    const formDataObject = {
      uniqueId: decryptedUniqueId,
      items: userDetails.map((userDetail, index) => {
        const amount1 = calculateAmount(userDetail, userDetail.tax);
      const taxinAmount = calculateTAX(userDetail);
      const totalAmountWithTax = parseFloat(amount1) + parseFloat(taxinAmount);
        return {
          itemId: userDetail.itemId || 0,
          itemDetails: userDetail.itemDetails || "",
          itemDetails2: itemDetails2[index] || userDetail.itemDetails2,
          account: userDetail.account || "",
          itemCode: userDetail.itemCode || "",
          hsnSac: userDetail.hsnSac || "",
          batchId: userDetail.batchId,
          rateOne: userDetail.rate1,
          size: userDetail.size || "",
          per: userDetail.per || "",
          quantity: userDetail.quantity || "",
          oldItemQuantity: oldQuantities[index] || "0",
          rate: userDetail.rate || formData.rate,
          discount: userDetail.discount || formData.discount,
          discountType: userDetail.discountType || formData.discountType,
          tax: userDetail.tax || formData.selectedTaxRate,
          rowDiscount: calculateDisRupees(userDetail),
          amount: amount1,
        rowWiseTotalWithGST: totalAmountWithTax.toFixed(2),
          description1: userDetail.description1 || "",
          description2: userDetail.description2 || "",
          customerTaxType: userState.state === customerState ? 1 : 2,
          cgst:
            userState.state === customerState
              ? (amount1 * userDetail.tax) / 100 / 2
              : 0,
          sgst:
            userState.state === customerState
              ? (amount1 * userDetail.tax) / 100 / 2
              : 0,
          igst:
            userState.state !== customerState
              ? (amount1 * userDetail.tax) / 100
              : 0,
        };
      }),
      ids: ids.map((id) => ({ id })),
      vendorName: fetchedVendorName || formData.vendorName,
      vendorId: selectedVendorId,
      orderNumber: formData.orderNumber,
      billsNumber: formData.billsNumber,
      oldBillNumber: oldBillNumber,
      lrNumber: formData.lrNumber,
      billsDate: dateValue || formData.billsDate,
      terms: fetchedPaymentTerms || formData.terms,
      dueDate: showDueDate
        ? formData.dueDate
        : dateValue1
        ? dateValue1
        : normalDateFormat(startDate1),
      salesPerson: fetchedSalesPerson?.value || formData.salesPerson,
      subject: formData.subject,
      subtotal: calculateSubTotal(),
      adjustment: formData.adjustment,
      adjustmentLabel: formData.adjustmentLabel,
      total: calculateTotal(),
      overallDiscount: disValue || 0,
      totalDiscount: disAllValue || 0,
      totalDiscountType: discountType,
      taxInAmount: totalTax || 0,
      type: tType || formData.type,
      value: formData.type === "TCS" ? discountAmountTcs : discountAmountTds,
      tdsTax: selectedTdsOption?.value,
      tcsTax: selectedTcsOption?.value,
      taxCheck: bussinessRegistered,
      sizeCheck: sizeCheck,
      customerNote: formData.customerNote,
      termsAndCondition: formData.termsAndCondition,
      discountAccount: formData.discountAccount,
      discountCheck: showDiscount,
      status: "Sent",
      manualCheck: manualCheck,
      manage: deletedItems,
      oldWareHouseName: oldWareHouseName,
      netRateCheck: columnCheck.netRateCheck,
      quantityCheck:columnCheck.quantityCheck,
      batchIdCheck: columnCheck.batchId,
      gstNumber: formData.gstNumber,
    };

    let newValidationMessage = "";
    if (!formData.vendorName) {
      newValidationMessage += "Please select a vendor \n";
    } else if (!formData.billsNumber) {
      newValidationMessage += "Please enter bill number.\n";
    } else if (!formData.billsDate) {
      newValidationMessage += "Please select a bill date   \n";
    } else if (!formData.dueDate) {
      newValidationMessage += "Please select a due date\n";
    }

    userDetails.forEach((item, index) => {
      if (item.itemDetails.trim() === "") {
        newValidationMessage += `Item name is required.\n`;
      }
      if (item.rate.trim() === "") {
        newValidationMessage += `Rate is required.\n`;
      } else if (item.rate.trim() === "0.0") {
        newValidationMessage += `Rate cannot be 0.0.\n`;
      }
      if (item.quantity.trim() === "") {
        newValidationMessage += `Quantity is required.\n`;
      }
      if (item.account === "") {
        newValidationMessage += `A valid account must be selected.\n`;
      }
    });

    setValidationMessage1(newValidationMessage);

    if (newValidationMessage) {
      window.scrollTo(0, 0);
      return;
    }
    setIsLoading(true);

    const response = await fetch(BASE_URL + "/updateBill", {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${jwtToken}`,
      },
      body: JSON.stringify(formDataObject),
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.status === "success") {
          swal({
            icon: "success",
            title: "Bill Updated",
          });
          props.handleCancel();
          setIsLoading(false);
        } else if (data.status === "error") {
          swal({
            icon: "error",
            title: data.responseMessage,
          });
          setIsLoading(false);
        }
      })
      .catch((error) => {
        swal({
          icon: "error",
          title: error.message,
        });
        setIsLoading(false);
      });
  };

  const insertDataIntoDatabaseAsDraft = async () => {
    const formDataObject = {
      uniqueId: decryptedUniqueId,
      items: userDetails.map((userDetail, index) => {
        const amount1 = calculateAmount(userDetail, userDetail.tax);
      const taxinAmount = calculateTAX(userDetail);
      const totalAmountWithTax = parseFloat(amount1) + parseFloat(taxinAmount);
        return {
          itemId: userDetail.itemId || 0,
          itemDetails: userDetail.itemDetails || "",
          itemDetails2: itemDetails2[index] || userDetail.itemDetails2,
          account: userDetail.account || "",
          itemCode: userDetail.itemCode || "",
          hsnSac: userDetail.hsnSac || "",
          batchId: userDetail.batchId,
          rateOne: userDetail.rate1,

          size: userDetail.size || "",
          per: userDetail.per || "",
          quantity: userDetail.quantity || "",
          oldItemQuantity: oldQuantities[index] || "0",
          rate: userDetail.rate || formData.rate,
          discount: userDetail.discount || formData.discount,
          discountType: userDetail.discountType || formData.discountType,
          tax: userDetail.tax || formData.selectedTaxRate,
          rowDiscount: calculateDisRupees(userDetail),
          amount: amount1,
        rowWiseTotalWithGST: totalAmountWithTax.toFixed(2),
          description1: userDetail.description1 || "",
          description2: userDetail.description2 || "",
          customerTaxType: userState.state === customerState ? 1 : 2,
          cgst:
            userState.state === customerState
              ? (amount1 * userDetail.tax) / 100 / 2
              : 0,
          sgst:
            userState.state === customerState
              ? (amount1 * userDetail.tax) / 100 / 2
              : 0,
          igst:
            userState.state !== customerState
              ? (amount1 * userDetail.tax) / 100
              : 0,
        };
      }),
      ids: ids.map((id) => ({ id })),
      vendorName: fetchedVendorName || formData.vendorName,
      vendorId: selectedVendorId,
      orderNumber: formData.orderNumber,
      billsNumber: formData.billsNumber,
      oldBillNumber: oldBillNumber,
      lrNumber: formData.lrNumber,
      billsDate: dateValue || formData.billsDate,
      terms: fetchedPaymentTerms || formData.terms,
      dueDate: showDueDate
        ? formData.dueDate
        : dateValue1
        ? dateValue1
        : normalDateFormat(startDate1),
      salesPerson: fetchedSalesPerson?.value || formData.salesPerson,
      subject: formData.subject,
      subtotal: calculateSubTotal(),
      adjustment: formData.adjustment,
      adjustmentLabel: formData.adjustmentLabel,
      total: calculateTotal(),
      overallDiscount: disValue || 0,
      totalDiscount: disAllValue || 0,
      totalDiscountType: discountType,
      taxInAmount: totalTax || 0,
      type: tType || formData.type,
      value: formData.type === "TCS" ? discountAmountTcs : discountAmountTds,
      tdsTax: selectedTdsOption?.value,
      tcsTax: selectedTcsOption?.value,
      taxCheck: bussinessRegistered,
      sizeCheck: sizeCheck,
      customerNote: formData.customerNote,
      termsAndCondition: formData.termsAndCondition,
      discountAccount: formData.discountAccount,
      discountCheck: showDiscount,
      status: "Draft",
      manualCheck: manualCheck,
      manage: deletedItems,
      oldWareHouseName: oldWareHouseName,
      batchIdCheck: columnCheck.batchIdCheck,
      netRateCheck: columnCheck.netRateCheck,
      quantityCheck:columnCheck.quantityCheck,
      gstNumber: formData.gstNumber,
    };

    let newValidationMessage = "";
    if (!formData.vendorName) {
      newValidationMessage += "Please select a vendor \n";
    } else if (!formData.billsNumber) {
      newValidationMessage += "Please enter bill number.\n";
    } else if (!formData.billsDate) {
      newValidationMessage += "Please select a bill date   \n";
    } else if (!formData.dueDate) {
      newValidationMessage += "Please select a due date\n";
    }

    userDetails.forEach((item, index) => {
      if (item.itemDetails.trim() === "") {
        newValidationMessage += `Item name is required.\n`;
      }
      if (item.rate.trim() === "") {
        newValidationMessage += `Rate is required.\n`;
      } else if (item.rate.trim() === "0.0") {
        newValidationMessage += `Rate cannot be 0.0.\n`;
      }
      if (item.quantity.trim() === "") {
        newValidationMessage += `Quantity is required.\n`;
      }
      if (item.account === "") {
        newValidationMessage += `A valid account must be selected.\n`;
      }
    });

    setValidationMessage1(newValidationMessage);

    if (newValidationMessage) {
      window.scrollTo(0, 0);
      return;
    }
    setIsLoading(true);

    const response = await fetch(BASE_URL + "/updateBill", {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${jwtToken}`,
      },
      body: JSON.stringify(formDataObject),
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.status === "success") {
          swal({
            icon: "success",
            title: "Bill Updated",
          });
          props.handleCancel();
          setIsLoading(false);
        } else if (data.status === "error") {
          swal({
            icon: "error",
            title: data.responseMessage,
          });
          setIsLoading(false);
        }
      })
      .catch((error) => {
        swal({
          icon: "error",
          title: error.message,
        });
        setIsLoading(false);
      });
  };

  const [oldQuantities, setOldQuantities] = useState([]);
  const [itemDetails2, setItemDetails2] = useState([]);

  useEffect(() => {
    const formattedId = billsNumber.replace(/\//g, "!");

    const fetchData = async () => {
      const response = await fetch(
        BASE_URL + `/fetchByBillNumber/${formattedId}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${jwtToken}`,
          },
          body: JSON.stringify({ uniqueId: decryptedUniqueId }),
        }
      );

      if (!response.ok) {
        throw new Error("Network response was not ok");
      }

      const data = await response.json();
      const resp = data.responseMessage[0];
      const itemIds = data.responseMessage.map((item) => item.id);
      setIds(itemIds);
      setOldBillNumber(resp.billsNumber);
      setUserDetails(data.responseMessage);
      setOldQuantities(data.responseMessage.map((item) => item.quantity));
      setItemDetails2(data.responseMessage.map((item) => item.itemDetails2));
      setItemDescriptions(
        data.responseMessage.map((item) => ({
          itemDetails: item.itemDetails,
          description: item.description2 || "",
        }))
      );
      setCustomerState(resp.state);
      setColumnCheck(resp);
      setFormData({
        vendorName: resp.vendorName,
        vendorId: resp.vendorId,
        orderNumber: resp.orderNumber,
        billsNumber: resp.billsNumber,
        state: resp.state,
        billsDate: resp.billsDate,
        terms: resp.terms,
        dueDate: resp.dueDate,
        itemDetails: resp.itemDetails,
        salesPerson: resp.salesPerson,
        subject: resp.subject,
        quantity: resp.quantity,
        rate: resp.rate,
        account: resp.account,
        discount: resp.discount,
        disscountType: resp.disscountType,
        tax: resp.tax,
        customerDetails: resp.customerDetails,
        amount: resp.amount,
        igst: resp.igst,
        cgst: resp.cgst,
        sgst: resp.sgst,
        type: resp.type,
        subtotal: resp.subtotal,
        adjustment: resp.adjustment,
        adjustmentLabel: resp.adjustmentLabel,
        total: resp.total,
        customerNote: resp.customerNote,
        termsAndCondition: resp.termsAndCondition,
        discountAccount: resp.discountAccount,
        taxType: resp.taxType,
        tcsTax: resp.tcsTax,
        tdsTax: resp.tdsTax,
        value: resp.value,
        wareHouseId: resp.wareHouseId,
        wareHouseName: resp.wareHouseName,
        gstNumber: resp.gstNumber,
      });
      setDisAllValue(resp.totalDiscount);
      setDiscountType(resp.totalDiscountType);
      setSelectedVendorId(resp.vendorId);
      setfetchedDiscountAccount(resp.discountAccount);
      setBussinessRegistered(resp.taxCheck);
      setShowDiscount(resp.discountCheck);
      setSizeCheck(resp.sizeCheck);
      setFetchedVendorName(resp.vendorName);
      setFetchedPaymentTerms(resp.terms);
      setFetchedSalesPerson(resp.salesPerson);
      setDisAllValue(resp.totalDiscount || "");
      setDiscountType(resp.totalDiscountType || "₹");

      if (resp.tcsTax !== null) {
        const selectedTcsOption = tcs.find(
          (option) => option.value === resp.tcsTax
        );
        setSelectedTcsOption(selectedTcsOption);
        setDiscountAmountTcs(parseFloat(resp.value));
      } else if (resp.tdsTax !== null) {
        const selectedTdsOption = tds.find(
          (option) => option.value === resp.tdsTax
        );
        setSelectedTdsOption(selectedTdsOption);
        setDiscountAmountTds(parseFloat(resp.value));
      }
      const taxGroups = calculateGroupedSGSTandCGST(data.responseMessage);
    };

    fetchData();
  }, []);

  const calculateDisRupees = (data, taxRate) => {
    const quantity = parseFloat(data.quantity || 0);
    const rate = parseFloat(data.rate || 0);
    const discount = parseFloat(data.discount || 0);
    const amount = quantity * rate;
    let discountedAmount = 0;
    if (data.discountType === "%") {
      discountedAmount = (amount * discount) / 100;
    } else if (data.discountType === "₹") {
      discountedAmount = discount;
    }

    return discountedAmount.toFixed(2);
  };

  useEffect(() => {
    if (fetchedVendorName) {
      const selectedCustomerObject = vendorNames.find(
        (person) => person.vendorDisplayName === fetchedVendorName
      );
      if (selectedCustomerObject) {
        const customerState = selectedCustomerObject.billingState;
        setCustomerState(customerState);
      }
    }
  }, [fetchedVendorName, vendorNames]);

  const handleVendorChange = (selectedOption) => {
    const selectedValue = selectedOption.value;
    setFetchedVendorName(selectedOption.value);
    setSelectedVendor(selectedValue); // Store the selected vendor's display name
    setFormData({ ...formData, vendorName: selectedValue });

    // Find the selected vendor object based on the display name
    const selectedVendorObject = vendorNames.find(
      (vendor) => vendor.vendorDisplayName === selectedValue
    );
    const fetchId = formData.vendorId;
    const selectId = selectedVendorObject.id;

    if (fetchId == selectId) {
      setCustomerState(formData.state);
      setSelectedVendorId(selectedVendorObject.id);
    } else if (selectedVendorObject) {
      setSelectedVendorId(selectedVendorObject.id);
      setCustomerState(selectedVendorObject.billingState);
      setSelectedTerms(selectedVendorObject.paymentTerms);
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevFormData) => ({
      ...prevFormData,
      [name]: value,
    }));
    setManualCheck("Yes");
    if (name === "adjustment") {
      setAdjustmentValue(value);
    }
  };

   const [searchTermItemCode, setSearchTermItemCode] = useState("");
    const [searchResultsItemCode, setSearchResultsItemCode] = useState([]);
    const [searchPerformedItemCode, setSearchPerformedItemCode] = useState(false);
    const [searchIndexItemCode, setSearchIndexItemCode] = useState(0);

  const handleItemCodeChange = (e, i) => {
    const value = e.target.value;
    const newDetails = [...userDetails];
    newDetails[i].itemCode = value;
    setUserDetails(newDetails);
    setSearchTermItemCode(value);
    setSearchPerformedItemCode(value !== "");
    setSearchIndexItemCode(i);

    if (value) {
      fetchItemByCode(value, i);
    }
  };

  const handleItemCodeSelect = (selectedItem, selectedItemId, index) => {
    setSearchResultsItemCode([]);
    const newDetails = [...userDetails];
    newDetails[index].itemCode = selectedItem;
    setUserDetails(newDetails);
    fetchItemRate(selectedItemId, index);
  };

  const fetchItemByCode = (itemCode, index) => {
    const results = dropdownData.filter(
      (item) =>
        item.itemCode &&
        item.itemCode.toLowerCase().includes(itemCode.toLowerCase())
    );
    setSearchResultsItemCode(results);
  };

  const handleInputChangess = (e, i) => {
    const { name, value } = e.target;
    const updatedUserDetails = [...userDetails];
    updatedUserDetails[i][name] = value;
    setUserDetails(updatedUserDetails);
    if (name === "tax") {
      const taxRate = parseFloat(value);
      setSelectedTaxRate(taxRate);
    }
  };

  const [show1, setShow1] = useState(false);
  const [showPopup, setShowPopup] = useState(false);
  const [billNumberPrefix, setBillNumberPrefix] = useState([]);
  const [billNumberNext, setBillNumberNext] = useState([]);

  const copyAdd = () => {
    if (show1) {
      setFormData({
        ...formData,
        billsNumber: billNumberPrefix + billNumberNext,
      });
      setManualCheck("No");
    } else {
      setManualCheck("Yes");
      setFormData({
        ...formData,
        billsNumber: "",
      });
    }
  };

  const setBill = () => {
    setShow1(true);
    fetchBill();
  };

  const fetchBill = () => {
    const requestData = {
      uniqueId: decryptedUniqueId,
      type: "bill",
    };

    const requestOptions = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${jwtToken}`,
      },
      body: JSON.stringify(requestData), // Convert the data to JSON format
    };

    fetch(BASE_URL + "/getCurruntNumberList2", requestOptions)
      .then((response) => response.json())
      .then((data) => {
        setBillNumberPrefix(data.responseMessage.prefix);
        setBillNumberNext(data.responseMessage.numbers);
      })
      .catch((error) => {
        console.error("Error fetching data: ", error);
      });
  };

  const handlePaymentTermsChange = (selectedOption) => {
    setSelectedTerms(selectedOption.value);
    setFetchedPaymentTerms(selectedOption.value);
    updateDueDate(dateValue, selectedOption.value);
  };

  const [adjustmentValue, setAdjustmentValue] = useState("");
  const [oppositeValue, setOppositeValue] = useState("");

  useEffect(() => {
    const parsedValue = parseFloat(adjustmentValue);
    if (!isNaN(parsedValue)) {
      const opposite = parsedValue * 1;
      setOppositeValue(opposite.toFixed(2));
    } else {
      setOppositeValue("");
    }
  }, [adjustmentValue]);

  const calculateTotal = () => {
    const subTotal = parseFloat(calculateSubTotal());
    const igst = parseFloat(calculateIGST());
    const adjustment = parseFloat(adjustmentValue || formData.adjustment) || 0;
    const totalDis = parseFloat(disValue || formData.totalDiscount) || 0;
    const total1 = subTotal + igst + adjustment - totalDis;
    const total = total1 + discountAmountTcs;
    return total.toFixed(2);
  };

  const calculateTotal2 = () => {
    const subTotal = parseFloat(calculateSubTotal());
    const igst = parseFloat(calculateIGST() || userDetails.igst);
    const adjustment = parseFloat(adjustmentValue || formData.adjustment) || 0; // Use the adjustment value if it's a valid number, otherwise, default to 0
    const total1 = subTotal + igst + adjustment;
    const total = total1 - disValue;
    const totalFinal = total - discountAmountTds;
    return totalFinal.toFixed(2);
  };

  const [total, setTotal] = useState("");
  useEffect(() => {
    const newTotal =
      formData.type === "TCS" ? calculateTotal() : calculateTotal2();
    setTotal(newTotal);
  }, [
    formData,
    discountAmountTds,
    discountAmountTcs,
    calculateTotal,
    calculateTotal2,
  ]);

  const handleSalesPersonChange = (value, id) => {
    const selectedValue = value;
    setFetchedSalesPerson(selectedValue);
    setFormData({ ...formData, salesPerson: selectedValue });
    const selectedSalesPersonObject = salesPersonData.find(
      (person) => person.name === selectedValue
    );
  };

  const fetchSalesData = () => {
    fetch(BASE_URL + `/getAllSalesPersonByUniqueId`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${jwtToken}`,
      },
      body: JSON.stringify({ uniqueId: decryptedUniqueId }),
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.status === "success") {
          const filteredData = data.responseMessage.filter(
            (item) => item.name !== "Others"
          );
          setSalesPersonData(filteredData);
        } else {
          console.error("Failed to fetch salesperson:", data.responseMessage);
        }
      })
      .catch((error) => {
        console.error("Error fetching salesperson:", error);
      });
  };

  useEffect(() => {
    fetchSalesData();
  }, []);

  const handleTaxChange = (e, index) => {
    setSelectedTaxRate(e.target.value);
    const newTaxRate = parseFloat(e.target.value);
    const updatedRow = [...userDetails];
    updatedRow[index].tax = newTaxRate;
    setUserDetails(updatedRow);
    calculateTotal();
  };

  const [discountType, setDiscountType] = useState("₹");
  const [disValue, setDisValue] = useState("");

  const calculateDiscount = () => {
    const amount = parseFloat(calculateSubTotal()).toFixed(2);

    if (discountType === "₹") {
      setDisValue(disAllValue);
    } else if (discountType === "%") {
      const percentageDiscount = (amount * disAllValue) / 100;
      setDisValue(percentageDiscount.toFixed(2));
    }
  };

  const handleDiscountTypeChange = (e) => {
    setDiscountType(e.target.value);
  };

  const handleDisAllValueChange = (e) => {
    setDisAllValue(e.target.value);
  };

  useEffect(() => {
    calculateDiscount();
  }, [disAllValue, discountType]);

  const [itemName, setItemName] = useState("");
  const [showItemModal, setShowItemModal] = useState(false);

  const [itemData, setItemData] = useState({
    uniqueId: decryptedUniqueId,
    description: "",
  });

  const handleItemClose = () => {
    setShowItemModal(false);
    setItemData({
      ...itemData,
      description: "",
    });
  };

  const handleItemChange = (event) => {
    const { name, value } = event.target;
    setItemData({ ...itemData, [name]: value });
  };

  const [itemDescriptions, setItemDescriptions] = useState([]);
  const handleItem = (event) => {
    event.preventDefault();

    const newItemDescription = {
      itemDetails: itemName,
      description: itemData.description,
    };

    setItemDescriptions((prevDescriptions) => {
      const existingIndex = prevDescriptions.findIndex(
        (desc) => desc.itemDetails === itemName
      );

      if (existingIndex !== -1) {
        const updatedDescriptions = [...prevDescriptions];
        updatedDescriptions[existingIndex] = newItemDescription;
        return updatedDescriptions;
      } else {
        return [...prevDescriptions, newItemDescription];
      }
    });

    setUserDetails((prevRows) =>
      prevRows.map((row) =>
        row.itemDetails === itemName
          ? { ...row, description2: itemData.description }
          : row
      )
    );

    setShowItemModal(false);
  };

  const handleItemShow = (itemDetails) => {
    const itemDescription = itemDescriptions.find(
      (desc) => desc.itemDetails === itemDetails
    );
    if (itemDescription) {
      setItemData({ description: itemDescription.description });
    } else {
      setItemData({ description: "" });
    }
    setItemName(itemDetails);
    setShowItemModal(true);
  };

  const fetchItemData = () => {
    const postApiUrl = BASE_URL + `/getAllItemData`;
    fetch(postApiUrl, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${jwtToken}`,
      },
      body: JSON.stringify({ uniqueId: decryptedUniqueId, vendorId: "" }),
    })
      .then((response) => response.json())
      .then((data) => {
        const responseData = data.responseMessage;
        setDropdownData(responseData.map((item) => item));
      })
      .catch((error) => {
        console.error("Error making POST request:", error);
      });
  };

  useEffect(() => {
    fetchItemData();
  }, []);

  const [searchIndex, setSearchIndex] = useState(0);

  useEffect(() => {
    const results = dropdownData.filter((item) =>
      item.name.toLowerCase().includes(searchTerm.toLowerCase())
    );
    setSearchResults(results);
  }, [searchTerm, dropdownData]);

  const handleSearchChange = (e, index) => {
    const value = e.target.value;
    const newUserDetails = [...userDetails];
    newUserDetails[index].itemDetails = value;
    setUserDetails(newUserDetails);

    setSearchTerm(value);
    setSearchPerformed(value !== "");
    setSearchIndex(index);
  };
  const handleItemDetailsChange = (e, index) => {
    const value = e.target.value;
    const newRow = [...userDetails];
    newRow[index].itemDetails = value;
    setUserDetails(newRow);
    setSearchTerm(value);
    setSearchPerformed(value !== "");
    setSearchIndex(index);
    if (value) {
      fetchItemRate(value, index);
    } else {
      handleSearchChange(value, index);
    }
  };

  const handleItemSelect = (selectedItem, selectedItemId, index) => {
    setSearchResults([]);
    const newUserDetails = [...userDetails];
    newUserDetails[index].itemDetails = selectedItem;
    setUserDetails(newUserDetails);
    fetchItemRate(selectedItemId, index);
  };

  const fetchItemRate = (itemId, index) => {
    const getApiUrl = BASE_URL + `/getItemData/${itemId}`;
    fetch(getApiUrl, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${jwtToken}`,
      },
    })
      .then((response) => response.json())
      .then((data) => {
        const rate = data.data.purchasePrice;
        const itemCode = data.data.itemCode;
        const description1 = data.data.description;
        const hsnSac = data.data.hsnCode;
        const itemName = data.data.name;
        const tax = data.data.intraStateTaxRate;
        const itemId = data.data.id;
        const updatedRow = [...userDetails];
        updatedRow[index].rate = rate;
        updatedRow[index].itemCode = itemCode;
        updatedRow[index].description1 = description1;
        updatedRow[index].hsnSac = hsnSac;
        updatedRow[index].itemDetails = itemName;
        updatedRow[index].tax = tax;
        updatedRow[index].itemId = itemId;
        setUserDetails(updatedRow);
        setSearchResults([]);
        handleAdd();
      })
      .catch((error) => {
        console.error("Error making POST request:", error);
      });
  };

  useEffect(() => {
    if (currentDate && selectedTerms && !dueDateChangedManually) {
      updateDueDate(new Date(currentDate), selectedTerms);
    }
  }, [currentDate, selectedTerms, dueDateChangedManually]);

  function convertDateStringToDate(dateString) {
    if (!dateString) {
      return null;
    }
    const [day, month, year] = dateString.split("-").map(Number);
    return new Date(year, month - 1, day);
  }

  const dateObject = convertDateStringToDate(formData.billsDate);

  const updateDueDate = (date, terms) => {
    setDueDateChangedManually(false);
    if (terms.startsWith("Net ")) {
      const daysToAdd = parseInt(terms.replace("Net ", ""));
      setDueDate(
        normalDateFormat(
          addDays(showDuePerTerm == true ? startDate : dateObject, daysToAdd)
        )
      );
      setShowDueDate(true);
    } else if (terms === "Due End Of The Month") {
      setDueDate(
        normalDateFormat(
          endOfMonth(showDuePerTerm == true ? startDate : dateObject)
        )
      );
      setShowDueDate(true);
    } else if (terms === "Due End Of Next Month") {
      setDueDate(
        normalDateFormat(
          endOfMonth(
            addMonths(showDuePerTerm == true ? startDate : dateObject, 1)
          )
        )
      );
      setShowDueDate(true);
    } else if (terms === "Due On Receipt") {
      setDueDate(
        normalDateFormat(showDuePerTerm == true ? startDate : dateObject)
      );
      setShowDueDate(true);
    } else if (terms === "Custom") {
      setShowDueDate(false);
    } else {
      setDueDate("");
    }
  };

  const updateDueDate1 = (date, terms) => {
    setDueDateChangedManually(false);
    if (terms.startsWith("Net ")) {
      const daysToAdd = parseInt(terms.replace("Net ", ""));
      setDueDate(normalDateFormat(addDays(date, daysToAdd)));
      setShowDueDate(true);
    } else if (terms === "Due End Of The Month") {
      setDueDate(normalDateFormat(endOfMonth(date)));
      setShowDueDate(true);
    } else if (terms === "Due End Of Next Month") {
      setDueDate(normalDateFormat(endOfMonth(addMonths(date, 1))));
      setShowDueDate(true);
    } else if (terms === "Due On Receipt") {
      setDueDate(normalDateFormat(date));
      setShowDueDate(true);
    } else if (terms === "Custom") {
      setShowDueDate(false);
    } else {
      setDueDate("");
    }
  };

  useEffect(() => {
    if (currentDate && selectedTerms && !dueDateChangedManually) {
      updateDueDate(new Date(currentDate), selectedTerms);
    }
  }, [currentDate, selectedTerms, dueDateChangedManually]);

  const [startDate, setStartDate] = useState(new Date());
  const [startDate1, setStartDate1] = useState(new Date());

  useEffect(() => {
    setStartDate(new Date());
    setStartDate1(new Date());
  }, []);

  const [dateValue, setDateValue] = useState("");
  const [dateValue1, setDateValue1] = useState("");
  const [showInvDate, setShowInvDate] = useState(true);

  const handleDate = (date) => {
    setStartDate(date);
    let normalFormat = date === null ? "" : normalDateFormat(date);
    setDateValue(normalFormat);
    updateDueDate1(date, selectedTerms);
  };

  const handleDate1 = (date) => {
    setStartDate1(date);
    let normalFormat = date === null ? "" : normalDateFormat(date);
    setDateValue1(normalFormat);
  };

  const normalDateFormat = (date) => {
    if (date) {
      return (
        ("0" + date.getDate()).slice(-2) +
        "-" +
        ("0" + (Number(date.getMonth()) + 1)).slice(-2) +
        "-" +
        date.getFullYear()
      );
    }
    return date;
  };

  const vendorOptions = vendorNames.map((names) => ({
    label: names.vendorDisplayName,
    value: names.vendorDisplayName,
  }));

  const optionPaymentTerms = [
    { value: "Net 15", label: "Net 15" },
    { value: "Net 30", label: "Net 30" },
    { value: "Net 45", label: "Net 45" },
    { value: "Net 60", label: "Net 60" },
    { value: "Due End Of The Month", label: "Due End Of The Month" },
    { value: "Due End Of Next Month", label: "Due End Of Next Month" },
    { value: "Due On Receipt", label: "Due On Receipt" },
    { value: "Custom", label: "Custom" },
  ];

  const [formDataVendor, setFormDataVendor] = useState({
    uniqueId: decryptedUniqueId,
    primaryContact: "Mr.",
    companyName: "",
    vendorDisplayName: "",
    vendorEmail: "",
    vendorPhone1: "",
    vendorPhone2: "",
    designation: "",
    department: "",
    website: "",
    currency: "INR- Indian Rupee",
    openingBalance: "",
    paymentTerms: "Net 15",
    facebook: "",
    twitter: "",
    billingAttention: "",
    billingCountry: "",
    billingAddress1: "",
    billingAddress2: "",
    billingCity: "",
    billingState: "",
    billingZipcode: "",
    billingPhone: "",
    shipAttention: "",
    shipCountry: "",
    shipAddress1: "",
    shipAddress2: "",
    shipCity: "",
    shipState: "",
    shipZipcode: "",
    shipPhone: "",
    sourceOfSupply: "[MH] - Maharashtra",
    gstTreatment: "",
    contactPerson: [
      {
        other: "",
        firstName: "",
        lastName: "",
        email: "",
        workphone: "",
        mobile: "",
      },
    ],
  });

  const handleCreateVendor = (event) => {
    const { name, value } = event.target;
    setFormDataVendor((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const discountAccountOptions = [
    {
      value: "[50311] Advertising And Marketing",
      label: "[50311] Advertising And Marketing",
    },
    {
      value: "[14141] Automobile Expense",
      label: "[14141] Automobile Expense",
    },
    { value: "[3193] Bad Debt", label: "[3193] Bad Debt" },
    {
      value: "[26135] Bank Fees and Charges",
      label: "[26135] Bank Fees and Charges",
    },
    {
      value: "[82626] Consultant Expense",
      label: "[82626] Consultant Expense",
    },
    {
      value: "[96192] Depreciation Expense",
      label: "[96192] Depreciation Expense",
    },
    {
      value: "[27448] IT and Internet Expenses",
      label: "[27448] IT and Internet Expenses",
    },
    { value: "[6979] Janitorial Expense", label: "[6979] Janitorial Expense" },
    { value: "[69281] Lodging", label: "[69281] Lodging" },
    {
      value: "[90818] Meals and Entertainment",
      label: "[90818] Meals and Entertainment",
    },
    { value: "[29025] Office Supplies", label: "[29025] Office Supplies" },
    { value: "[29758] Other Expenses", label: "[29758] Other Expenses" },
    { value: "[24403] Postage", label: "[24403] Postage" },
    {
      value: "[84981] Printing and Stationery",
      label: "[84981] Printing and Stationery",
    },
    { value: "[89752] Rent Expense", label: "[89752] Rent Expense" },
    {
      value: "[46854] Repairs and Maintainece",
      label: "[46854] Repairs and Maintainece",
    },
    {
      value: "[73789] Salaries and Employee Wages",
      label: "[73789] Salaries and Employee Wages",
    },
    { value: "[9939] Telephone Expense", label: "[9939] Telephone Expense" },
    { value: "[24350] Travel Expense", label: "[24350] Travel Expense" },
    { value: "[81688] Uncategorized", label: "[81688] Uncategorized" },
    {
      value: "[71978] Depreciation and Amortisation",
      label: "[71978] Depreciation and Amortisation",
    },
    { value: "[54857] Marchandise", label: "[54857] Marchandise" },
    {
      value: "[65773] Raw Materials and Comsumables",
      label: "[65773] Raw Materials and Comsumables",
    },
    {
      value: "[53602] Transportation Expense",
      label: "[53602] Transportation Expense",
    },
    { value: "[7074] Cost of Goods Sold", label: "[7074] Cost of Goods Sold" },
    { value: "[79169] Job Costing", label: "[79169] Job Costing" },
    { value: "[58139] Labor", label: "[58139] Labor" },
    { value: "[38921] Materials", label: "[38921] Materials" },
    { value: "[71810] Subcontractor", label: "[71810] Subcontractor" },
    {
      value: "[48773] Exchange Gain or Loss",
      label: "[48773] Exchange Gain or Loss",
    },
  ];

  const handleDiscountAccountChange = (selectedOption) => {
    setSelectedDiscountAccount(selectedOption);
    setfetchedDiscountAccount(selectedOption);
    setFormData({
      ...formData,
      discountAccount: selectedOption.value,
    });
  };

  const [showNewVendor, setShowNewVendor] = useState(false);

  const handleNewVendorClose = () => setShowNewVendor(false);
  const handleNewVendorShow = () => setShowNewVendor(true);
  const [validationMessage, setValidationMessage] = useState("");

  const handleAddVendor = () => {
    let newValidationMessage = "";

    if (!formDataVendor.vendorDisplayName) {
      newValidationMessage += "Please enter a vendor display name.\n";
    } else if (
      formDataVendor.email &&
      !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formDataVendor.email)
    ) {
      newValidationMessage += "Please enter a valid email address.\n";
    }

    setValidationMessage(newValidationMessage);

    if (newValidationMessage) {
      return; // Exit function if validation fails
    }

    fetch(BASE_URL + "/insertVendor", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${jwtToken}`,
      },
      body: JSON.stringify(formDataVendor),
    })
      .then((response) => {
        if (response.ok) {
          swal({
            icon: "success",
            title: "Vendor Added Successfully",
            text: "",
          });
          setShowNewVendor(false);
          fetchAllVendors();
        } else {
          swal({
            icon: "error",
            title: "Failed to post Vendor data",
            text: "",
          });
          setShowNewVendor(true);
        }
      })
      .catch((error) => {
        swal({
          icon: "error",
          title: "Network Error",
          text: "An error occurred while communicating with the server.",
        });
        setShowNewVendor(true);
      });
  };

  const optionsSalesPerson = salesPersonData.map((sales) => ({
    value: sales.name,
    label: sales.name,
  }));

  const [salesData, setSalesData] = useState({
    uniqueId: decryptedUniqueId,
    name: "",
    email: "",
  });

  const handleSalesInputChange = (event) => {
    const { name, value } = event.target;
    setSalesData({ ...salesData, [name]: value });
  };

  const [showSalesModal, setShowSalesModal] = useState(false);

  const handleSalesClose = () => setShowSalesModal(false);
  const handleSalesShow = () => setShowSalesModal(true);

  const handleSalesPerson = (event) => {
    event.preventDefault();

    fetch(BASE_URL + "/createSalesperson", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${jwtToken}`,
      },
      body: JSON.stringify(salesData),
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.status === "success") {
          swal({
            icon: "success",
            title: "Tax Rate Added Successfully",
          });
          setShowSalesModal(false);
          fetchSalesData();
        } else {
          swal({
            icon: "error",
            title: "Failed To Create Tax Rate",
          });
          setShowSalesModal(true);
        }
      })
      .catch((error) => {
        swal({
          icon: "error",
          title: "An Error Occured While Creating Tax RAte ",
        });
        setShowSalesModal(true);
      });
  };

  const customStyles3 = {
    container: (provided, state) => ({
      ...provided,
    }),
    control: (provided, state) => ({
      ...provided,
      width: "100%",
      background: "#F6F6F6",
      borderRadius: "7px",
      height: "20px",
      boxShadow: state.isFocused ? null : null,
    }),

    valueContainer: (provided, state) => ({
      ...provided,
      marginLeft: "8px",
      height: "20px",
      padding: "0 6px",
    }),

    input: (provided, state) => ({
      ...provided,
      margin: "0px",
    }),
    indicatorSeparator: (state) => ({
      display: "none",
    }),
    indicatorsContainer: (provided, state) => ({
      ...provided,
      // height: "40px",
    }),
  };
  const generateNamePairs = () => {
    const { primaryContact, firstName, lastName, companyName } = formDataVendor;
    const pairs = [];

    if (firstName && lastName) {
      pairs.push(`${primaryContact} ${firstName} ${lastName}`);
      pairs.push(`${firstName} ${lastName}`);
      pairs.push(`${lastName} , ${firstName}`);
      pairs.push(`${companyName}`);
    }

    return pairs;
  };

  useEffect(() => {
    if (
      (selectedTaxType === "TDS" || formData.type === "TDS") &&
      selectedTdsOption &&
      selectedTdsOption.discount
    ) {
      const subtotal = calculateSubTotal();
      const discountedTotal = applyDiscount(
        subtotal,
        selectedTdsOption.discount
      );
    } else if (
      (selectedTaxType === "TCS" || formData.type === "TCS") &&
      selectedTcsOption &&
      selectedTcsOption.discount
    ) {
      const subtotal = calculateSubTotal();
      const discountedTotal = applyDiscountTcs(
        subtotal,
        selectedTcsOption.discount
      );
    }
  }, [userDetails]);

  return (
    <div>
      <div className="my-3">
        <div className="d-flex align-items-center ml-1 mt-4">
          <div
            className="cursor-pointer d-flex justify-content-center align-items-center"
            style={{
              backgroundColor: "white",
              borderRadius: "50%",
              height: "35px",
              width: "38px",
            }}
          >
            <ArrowBackIosIcon
              width={2}
              onClick={handleCancleClick}
              className="arrow-child"
            />
          </div>
          <div className="newcustomer-head ml-2">
            <h5
              className="ml-1 mb-0"
              style={{ letterSpacing: "1px", color: "#086bd5de" }}
            >
              Update Bill
            </h5>
          </div>
        </div>
      </div>
      {validationMessage1 && (
        <Alert severity="error" className="mt-0">
          {validationMessage1.split("\n").map((message, index) => (
            <div key={index}>{message}</div>
          ))}
        </Alert>
      )}{" "}
      <div className="card border-0 my-3">
        <div className="pl-4 pr-4">
          <div className="row pt-2">
            <div className="salespersonbox">
              <div className="text-style">
                Vendor Name <span className="valid"> *</span>
              </div>
              <Select
                value={vendorOptions.find(
                  (option) => option.value === fetchedVendorName
                )}
                onChange={handleVendorChange}
                options={vendorOptions}
                placeholder="Select a Vendor"
                styles={{
                  container: (provided) => ({
                    ...provided,
                    marginTop: "10px",
                    width: "250px",
                  }),
                  control: (provided) => ({
                    ...provided,
                    backgroundColor: "#F6F6F6",
                    borderRadius: "7px",
                    height: "46px",
                  }),
                  singleValue: (provided) => ({
                    ...provided,
                    height: "19px",
                  }),
                }}
              />
              <button
                type="button"
                class="btn p-0"
                onClick={handleNewVendorShow}
              >
                <span
                  class="text-primary"
                  style={{ fontSize: "12px", fontWeight: "500" }}
                >
                  New Vendor
                </span>
              </button>

              {/* New vendor popup*/}
              <Modal
                size="lg"
                show={showNewVendor}
                onHide={handleNewVendorClose}
              >
                <div class="modal-header d-flex align-items-center pb-2 pt-2">
                  <h5 class="modal-title fs-5" id="newcustomerPopup">
                    New Vendor
                  </h5>
                  <button
                    type="button"
                    className="btn pr-0"
                    onClick={handleNewVendorClose}
                  >
                    <ion-icon
                      name="close-circle-outline"
                      size="large"
                      style={{ width: "28px" }}
                    ></ion-icon>
                  </button>
                </div>
                <Modal.Body className="p-0 pb-3">
                  {validationMessage && (
                    <Alert severity="error" className="mt-0">
                      {validationMessage.split("\n").map((message, index) => (
                        <div key={index}>{message}</div>
                      ))}
                    </Alert>
                  )}{" "}
                  <div className="container">
                    <div className="row d-inline-flex">
                      <div className="modalinputchild">
                        <div className="text-style"> Salutation </div>
                        <select
                          className="form-control"
                          name="primaryContact"
                          value={formDataVendor.primaryContact}
                          onChange={handleCreateVendor}
                          style={{
                            borderRadius: "7px",
                            backgroundColor: "#f5f5f5",
                            width: "200px",
                            height: "35px",
                            fontSize: "13px",
                            marginTop: "10px",
                          }}
                        >
                          <option value="Mr.">Mr.</option>
                          <option value="Mrs.">Mrs.</option>
                          <option value="Ms.">Ms.</option>
                          <option value="Miss.">Miss.</option>
                          <option value="Dr.">Dr.</option>
                        </select>
                      </div>
                      <div className="modalinputchild">
                        <div className="text-style">First Name</div>
                        <input
                          className="form-control"
                          placeholder="First Name"
                          name="firstName"
                          value={formDataVendor.firstName}
                          onChange={handleCreateVendor}
                          id="firstName"
                          type="text"
                        />
                      </div>
                      <div className="modalinputchild">
                        <div className="text-style">Last Name</div>
                        <input
                          className="form-control"
                          placeholder="Last Name"
                          id="lastName"
                          name="lastName"
                          value={formDataVendor.lastName}
                          onChange={handleCreateVendor}
                          type="text"
                        />
                      </div>
                    </div>
                    <div className="row d-inline-flex pt-2">
                      <div className="modalinputchild">
                        <div className="text-style"> Vendor Email</div>
                        <input
                          className="form-control"
                          placeholder="Customer Email"
                          name="vendorEmail"
                          type="text"
                          value={formDataVendor.vendorEmail}
                          onChange={handleCreateVendor}
                        />
                      </div>
                      <div className="modalinputchild">
                        <div className="text-style">
                          {" "}
                          Vendor Display Name <span className="valid">
                            *
                          </span>{" "}
                        </div>
                        <input
                          className="form-control"
                          placeholder="Vendor Display Name"
                          list="vendorDisplayName"
                          name="vendorDisplayName"
                          value={formDataVendor.vendorDisplayName}
                          onChange={handleCreateVendor}
                          style={{
                            borderRadius: "7px",
                            backgroundColor: "#f5f5f5",
                            width: "200px",
                            height: "40px",
                            fontSize: "13px",
                            marginTop: "10px",
                          }}
                        />
                        <datalist id="vendorDisplayName">
                          {generateNamePairs().map((pair, index) => (
                            <option key={index} value={pair} />
                          ))}
                        </datalist>{" "}
                      </div>

                      <div className="modalinputchild">
                        <div className="text-style">Company Name</div>
                        <input
                          className="form-control"
                          placeholder="Add company name"
                          name="companyName"
                          type="text"
                          value={formDataVendor.companyName}
                          onChange={handleCreateVendor}
                        />
                      </div>
                    </div>
                    <div className="row d-inline-flex pt-2">
                      <div className="modalinputchild">
                        <div className="text-style">Vendor Phone</div>
                        <input
                          className="form-control"
                          placeholder="Work Phone"
                          name="vendorPhone1"
                          type="text"
                          value={formDataVendor.vendorPhone1}
                          onChange={handleCreateVendor}
                        />
                      </div>
                      <div className="modalinputchild">
                        <div className="text-style">Mobile</div>
                        <input
                          className="form-control"
                          placeholder="Mobile"
                          name="vendorPhone2"
                          type="text"
                          value={formDataVendor.vendorPhone2}
                          onChange={handleCreateVendor}
                        />
                      </div>
                    </div>
                  </div>
                </Modal.Body>
                <Modal.Footer className="p-2">
                  <div className="modal-bottombtns">
                    <button
                      type="button"
                      class="modalbtn-1 btn mt-0"
                      onClick={handleNewVendorClose}
                    >
                      Close
                    </button>
                    <button
                      type="button"
                      class="modalbtn-3 btn btn-primary"
                      onClick={handleAddVendor}
                    >
                      Create Vendor
                    </button>
                  </div>
                </Modal.Footer>
              </Modal>
            </div>
          </div>

          {/* BillNumber */}
          <div className="row d-inline-flex pt-3">
            <div className="inputchild">
              <div className="text-style">
                Bill <span className="valid"> *</span>
              </div>
              <input
                className="form-control"
                placeholder="Bills Number"
                name="billsNumber"
                value={formData.billsNumber}
                onChange={handleInputChange}
                type="text"
                style={{
                  padding: "12px",
                  backgroundColor: "#F6F6F6",
                  borderRadius: "7px",
                  color: "black",
                  height: "40px",
                  "::placeholder": {
                    color: "var(--Black-light-text, rgba(0, 0, 0, 0.25))",
                  },
                }}
              />
              <button
                type="button"
                className="btn p-0"
                data-bs-toggle="modal"
                data-bs-target="#generatePop"
              >
                <span
                  className="text-primary"
                  style={{ fontSize: "12px", fontWeight: "500" }}
                >
                  Generate
                </span>
              </button>
              <div
                className="modal fade"
                id="generatePop"
                tabindex="-1"
                aria-labelledby="exampleModalLabel"
                aria-hidden="true"
              >
                <div className="modal-dialog">
                  <div className="modal-content">
                    <div className="modal-header d-flex align-items-center pb-2 pt-2">
                      <h5 className="modal-title fs-5" id="generateinvoiceHead">
                        Bill Number
                      </h5>
                      <button
                        type="button"
                        className="btn pr-0"
                        data-bs-dismiss="modal"
                        aria-label="Close"
                      >
                        <ion-icon
                          name="close-circle-outline"
                          size="large"
                          style={{ width: "28px" }}
                        ></ion-icon>
                      </button>
                    </div>
                    <div className="modal-body pt-1 pb-1">
                      <div className="popupinvoice-container ml-2 mt-2 mr-2 mb-0">
                        <div className="row headline">
                          <div className="customer-headline-label">
                            <label className="form-label">
                              <span className="headline">
                                Your bill numbers are set on auto-generate mode
                                to save your time.
                                <br /> Are you sure about changing this setting?
                              </span>
                            </label>
                          </div>
                        </div>
                        <div className="row mt-3">
                          <label className="customer-rdiobox-label d-flex align-items-center">
                            <input
                              className="mr-2"
                              type="radio"
                              name="cus_type"
                              id="cus_bus"
                              value="Business"
                              onClick={setBill}
                            />
                            <span className="customer-option">
                              Continue auto-generating bill numbers
                            </span>
                          </label>
                        </div>
                        {show1 && (
                          <div className="row ml-3 mb-3">
                            <div className="customer-generate-inputfield">
                              <span>Prefix</span>
                              <input
                                className="form-control mt-1"
                                placeholder="Prefix"
                                value={billNumberPrefix}
                                onChange={(e) =>
                                  setBillNumberPrefix(e.target.value)
                                }
                              />
                            </div>
                            <div className="customer-generate-inputfield2">
                              <span>Next Number</span>
                              <input
                                className="form-control mt-1"
                                placeholder="Next Number"
                                value={billNumberNext}
                                onChange={(e) =>
                                  setBillNumberNext(e.target.value)
                                }
                              />
                            </div>
                          </div>
                        )}
                        <div className="row mt-1">
                          <label className="customer-rdiobox-label d-flex align-items-center">
                            <input
                              className="mr-2"
                              type="radio"
                              name="cus_type"
                              id="cus_bus"
                              value="Business"
                              onClick={() => {
                                setShow1(false);
                              }}
                            />
                            <span className="customer-option">
                              I will add them manually each time
                            </span>
                          </label>
                        </div>
                      </div>
                    </div>
                    <div className="modal-footer">
                      <div className="modal-bottombtns">
                        <button
                          type="button"
                          class="modalbtn-1 btn mt-0"
                          data-bs-dismiss="modal"
                        >
                          Close
                        </button>
                        <button
                          type="button"
                          class="modalbtn-3 btn btn-primary"
                          onClick={() => {
                            copyAdd();
                          }}
                          data-bs-dismiss="modal"
                        >
                          Save Changes
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="inputchild">
              <div className="text-style">Order Number</div>
              <input
                className="form-control"
                placeholder="Order Number"
                name="orderNumber"
                value={formData.orderNumber}
                onChange={handleInputChange}
                type="text"
                style={{
                  padding: "12px",
                  backgroundColor: "#F6F6F6",
                  borderRadius: "7px",
                  color: "black",
                  height: "40px",
                  "::placeholder": {
                    color: "var(--Black-light-text, rgba(0, 0, 0, 0.25))",
                  },
                }}
              />
            </div>
            <div className="inputchild">
              <div className="text-style">LR Number</div>
              <input
                className="form-control"
                placeholder="LR Number"
                name="lrNumber"
                value={formData.lrNumber}
                onChange={handleInputChange}
                type="text"
                style={{
                  padding: "12px",
                  backgroundColor: "#F6F6F6",
                  borderRadius: "7px",
                  color: "black",
                  height: "40px",
                  "::placeholder": {
                    color: "var(--Black-light-text, rgba(0, 0, 0, 0.25))",
                  },
                }}
              />
            </div>
          </div>
          <div className="row pt-3">
            <div className="inputchild">
              <div className="text-style">
                Bill Date <span className="valid"> *</span>
              </div>
              {showInvDate ? (
                <input
                  className="form-control"
                  type="text"
                  value={formData.billsDate}
                  onClick={() => {
                    setShowInvDate(false);
                    setFormData({
                      ...formData,
                      billsDate: normalDateFormat(startDate),
                    });
                    handleDate(startDate);
                    setShowDuePerTerm(true);
                  }}
                  readOnly
                  style={{
                    backgroundColor: "#F6F6F6",
                    borderRadius: "7px",
                    padding: "12px",
                    height: "38px",
                    width: "260.8px",
                  }}
                />
              ) : (
                <div className="customDatePickerWidth">
                  <DatePicker
                    className="form-control"
                    selected={startDate}
                    dateFormat="dd-MM-yyyy"
                    onChange={(date) => handleDate(date)}
                    showIcon
                    toggleCalendarOnIconClick
                  />
                </div>
              )}
            </div>

            <div className="salespersonbox">
              <div className="text-style">Terms</div>
              <Select
                // className="dropdown-field"
                options={optionPaymentTerms}
                value={optionPaymentTerms.find(
                  (option) => option.value === fetchedPaymentTerms
                )}
                onChange={handlePaymentTermsChange}
                placeholder="Select Terms"
                styles={{
                  container: (provided) => ({
                    ...provided,
                    marginTop: "10px",
                    width: "250px",
                  }),
                  control: (provided) => ({
                    ...provided,
                    backgroundColor: "#F6F6F6",
                    borderRadius: "7px",
                    height: "46px",
                  }),
                  singleValue: (provided) => ({
                    ...provided,
                    height: "19px",
                  }),
                }}
              />
            </div>
            <div className="inputchild">
              <div className="text-style">
                Due Date <span className="valid"> *</span>
              </div>
              {showDueDate ? (
                <input
                  className="form-control"
                  type="text"
                  value={dueDate || formData.dueDate}
                  onClick={(e) => {
                    setShowDueDate(false);
                    setSelectedTerms("Custom");
                    setFormData({ ...formData, terms: "Custom" });
                    setFetchedPaymentTerms("Custom");
                  }}
                  style={{
                    padding: "12px",
                    backgroundColor: "#F6F6F6",
                    borderRadius: "7px",
                    color: "black",
                    height: "40px",
                    "::placeholder": {
                      color: "var(--Black-light-text, rgba(0, 0, 0, 0.25))",
                    },
                  }}
                  readOnly
                />
              ) : (
                <div className="customDatePickerWidth">
                  <DatePicker
                    className="form-control"
                    selected={startDate1}
                    dateFormat="dd/MM/yyyy"
                    onChange={(date) => handleDate1(date)}
                  />
                </div>
              )}
            </div>
          </div>

          {/* salesPerson */}
          <div className="row pt-3">
            <div className="salespersonbox">
              <div className="text-style">Salesperson</div>
              <Select
                options={optionsSalesPerson}
                value={optionsSalesPerson.find(
                  (option) => option.value === fetchedSalesPerson
                )}
                onChange={handleSalesPersonChange}
                placeholder="Select a SalesPerson"
                styles={{
                  container: (provided) => ({
                    ...provided,
                    marginTop: "10px",
                    width: "250px",
                  }),
                  control: (provided) => ({
                    ...provided,
                    backgroundColor: "#F6F6F6",
                    borderRadius: "7px",
                    height: "46px",
                  }),
                  singleValue: (provided) => ({
                    ...provided,
                    height: "19px",
                  }),
                }}
              />
              <button type="button" class="btn p-0" onClick={handleSalesShow}>
                <span
                  class="text-primary"
                  style={{ fontSize: "12px", fontWeight: "500" }}
                >
                  New Sales Person
                </span>
              </button>

              {/*Sales Person Popup*/}
              <Modal show={showSalesModal} onHide={handleSalesClose}>
                <div class="modal-header d-flex align-items-center pb-2 pt-2">
                  <h5 class="modal-title fs-5" id="salespersonHead">
                    Add Sales Person
                  </h5>
                  <button
                    type="button"
                    className="btn pr-0"
                    onClick={handleSalesClose}
                  >
                    <ion-icon
                      name="close-circle-outline"
                      size="large"
                      style={{ width: "28px" }}
                    ></ion-icon>
                  </button>
                </div>
                <Modal.Body>
                  <div className="row pt-2">
                    <div className="modalsalesinput">
                      <label className="form-label">
                        <span style={{ color: "#0b0a0ab5" }}>Name</span>
                      </label>
                      <input
                        className="form-control"
                        placeholder="Name"
                        id="name"
                        name="name"
                        type="text"
                        value={salesData.name}
                        onChange={handleSalesInputChange}
                      />
                    </div>
                  </div>
                  <div className="row pt-4">
                    <div className="modalsalesinput">
                      <label className="form-label">
                        <span style={{ color: "#0b0a0ab5" }}>Email</span>
                      </label>
                      <input
                        className="form-control"
                        placeholder="Email"
                        id="email"
                        name="email"
                        type="text"
                        value={salesData.email}
                        onChange={handleSalesInputChange}
                      />
                    </div>
                  </div>
                </Modal.Body>
                <Modal.Footer className="p-2">
                  <div className="modal-bottombtns">
                    <button
                      type="button"
                      class="modalbtn-1 btn mt-0"
                      onClick={handleSalesClose}
                    >
                      Close
                    </button>
                    <button
                      type="button"
                      class="modalbtn-3 btn btn-primary"
                      onClick={handleSalesPerson}
                      data-bs-dismiss="modal"
                    >
                      Create Sales Person
                    </button>
                  </div>
                </Modal.Footer>
              </Modal>
            </div>
            <div className="subjectbox ml-3">
              <div className="text-style">Subject</div>
              <input
                type="text"
                className="form-control subject-textarea"
                placeholder="Subject..."
                name="subject"
                value={formData.subject}
                onChange={handleInputChange}
                style={{
                  width: "34.5vw",
                  padding: "12px",
                  backgroundColor: "#F6F6F6",
                  borderRadius: "7px",
                  color: "black",
                  height: "40px",
                  "::placeholder": {
                    color: "var(--Black-light-text, rgba(0, 0, 0, 0.25))",
                  },
                }}
              />
            </div>
          </div>

          <>
            <Row className="mt-4">
              <Col md="3">
                <label
                  className="text-primary"
                  style={{ fontSize: 14, fontWeight: "600" }}
                >
                  ITEM INFO
                </label>
              </Col>
            </Row>
            <div className="">
              <div>
                <Row>
                  <Col>
                    <Card className="mb-3">
                      <div style={{ overflowX: "auto" }}>
                        <table
                          className="table table-bordered  mb-0"
                          style={{
                            width: "100%",
                          }}
                        >
                          <thead className="text-center">
                            <tr>
                              <th
                                style={{
                                  whiteSpace: "nowrap",
                                  minWidth: "350px",
                                }}
                              >
                                {" "}
                                ITEM DETAILS
                              </th>
                              {columnCheck.batchIdCheck === "YES" && (
                                <th
                                  style={{
                                    whiteSpace: "nowrap",
                                    minWidth: "100px",
                                  }}
                                >
                                  {" "}
                                  BATCH ID
                                </th>
                              )}
                               <th
                              style={{
                                whiteSpace: "nowrap",
                                minWidth: "100px",
                              }}
                            >
                              ITEM CODE
                            </th>
                              {columnCheck.hsnCheck === "YES" && (
                                <th
                                  style={{
                                    whiteSpace: "nowrap",
                                    minWidth: "100px",
                                  }}
                                >
                                  {" "}
                                  HSN
                                </th>
                              )}
                              <th
                                style={{
                                  whiteSpace: "nowrap",
                                  minWidth: "100px",
                                }}
                              >
                                {" "}
                                ACCOUNT
                              </th>
                              {columnCheck.sizeCheck === "YES" && (
                                <th
                                  style={{
                                    whiteSpace: "nowrap",
                                    minWidth: "100px",
                                  }}
                                >
                                  {" "}
                                  SIZE
                                </th>
                              )}
                               <th
                                style={{
                                  whiteSpace: "nowrap",
                                  minWidth: "100px",
                                }}
                              >
                                {" "}
                                PER
                              </th>
                              {columnCheck.quantityCheck === "YES" && (
                              <th
                                style={{
                                  whiteSpace: "nowrap",
                                  minWidth: "100px",
                                }}
                              >
                                {" "}
                                QUANTITY
                              </th>
                              )}
                              {columnCheck.netRateCheck === "YES" && (
                                <th
                                  style={{
                                    whiteSpace: "nowrap",
                                    minWidth: "100px",
                                  }}
                                >
                                  {" "}
                                  RATE
                                </th>
                              )}
                              <th
                                style={{
                                  whiteSpace: "nowrap",
                                  minWidth: "100px",
                                }}
                              >
                                {" "}
                                {columnCheck.netRateCheck === "YES"
                                  ? "NET RATE"
                                  : "RATE"}
                              </th>
                              {columnCheck.discountCheck === "YES" && (
                                <th
                                  style={{
                                    whiteSpace: "nowrap",
                                    minWidth: "100px",
                                  }}
                                >
                                  {" "}
                                  DISCOUNT
                                </th>
                              )}
                              {bussinessRegistered === "YES" && (
                                <th
                                  style={{
                                    whiteSpace: "nowrap",
                                    minWidth: "100px",
                                  }}
                                >
                                  {" "}
                                  TAX
                                </th>
                              )}
                              <th
                                style={{
                                  whiteSpace: "nowrap",
                                  minWidth: "100px",
                                }}
                              >
                                {" "}
                                AMOUNT
                              </th>
                              <th
                                style={{
                                  whiteSpace: "nowrap",
                                  minWidth: "100px",
                                }}
                              >
                                {" "}
                                ACTION
                              </th>
                            </tr>
                          </thead>

                          {userDetails.map((data, i) => {
                            const amount = calculateAmount(data, data.tax);
                            const taxinAmount = calculateTAX(data);
                            const totalAmountWithTax = parseFloat(amount) + parseFloat(taxinAmount);
                            const itemDescription = itemDescriptions.find(
                              (desc) => desc.itemDetails === data.itemDetails
                            );
                            return (
                              <tbody key={i}>
                                <tr>
                                  <td style={{ whiteSpace: "nowrap" }}>
                                    <div
                                      style={{
                                        display: "flex",
                                        alignItems: "center",
                                      }}
                                    >
                                      <input
                                        className="form-control noBorder"
                                        placeholder="Search items..."
                                        value={data.itemDetails}
                                        onChange={(e) =>
                                          handleItemDetailsChange(e, i)
                                        }
                                        style={{ flex: 1 }}
                                      />
                                      {data.itemDetails && (
                                        <button
                                          type="button"
                                          className="btn p-0"
                                          onClick={() =>
                                            handleItemShow(data.itemDetails)
                                          }
                                          style={{ marginLeft: "10px" }}
                                        >
                                          <span
                                            className="text-primary"
                                            style={{
                                              fontSize: "12px",
                                              fontWeight: "500",
                                            }}
                                          >
                                            Edit
                                          </span>
                                        </button>
                                      )}
                                    </div>
                                    {itemDescription && (
                                      <div
                                        style={{
                                          marginTop: "10px",
                                          color: "#6c757d",
                                          whiteSpace: "pre-line",
                                        }}
                                      >
                                        {itemDescription.description}
                                      </div>
                                    )}
                                    {searchPerformed &&
                                      data.itemDetails &&
                                      i === searchIndex && (
                                        <div
                                          style={{
                                            position: "absolute",
                                            zIndex: 9999, // Higher than scrollbar
                                            top: "100%", // Position below input
                                            left: 0,
                                            width: "60%",
                                          }}
                                        >
                                          {searchResults.length === 0 && ""}
                                          {searchResults.length > 0 && (
                                            <ul
                                              style={{
                                                listStyleType: "none",
                                                padding: 0,
                                                position: "absolute",
                                                top: "calc(100% + 10px)",
                                                left: 0,
                                                zIndex: 1000,
                                                backgroundColor: "#FFF",
                                                boxShadow:
                                                  "0px 0px 10px rgba(0, 0, 0, 0.2)",
                                                borderRadius: "5px",
                                                width: "100%",
                                                maxHeight: "200px", // Set a max height for the list
                                                overflowY: "auto", // Enable vertical scrolling
                                              }}
                                            >
                                              {searchResults.map(
                                                (result, index) => (
                                                  <li
                                                    key={index}
                                                    onClick={() =>
                                                      handleItemSelect(
                                                        result.name,
                                                        result.id,
                                                        i
                                                      )
                                                    }
                                                    onMouseEnter={(e) => {
                                                      e.target.style.backgroundColor =
                                                        "#408dfb";
                                                      e.target.style.color =
                                                        "#FFF";
                                                      e.target.style.borderRadius =
                                                        "5px"; // Apply border radius on hover
                                                    }}
                                                    onMouseLeave={(e) => {
                                                      e.target.style.backgroundColor =
                                                        "";
                                                      e.target.style.color =
                                                        "#000";
                                                      e.target.style.borderRadius =
                                                        ""; // Reset border radius
                                                    }}
                                                    style={{
                                                      padding: "12px",
                                                      cursor: "pointer",
                                                      whiteSpace: "nowrap", // Prevent text from overflowing
                                                      overflow: "hidden", // Hide overflow text
                                                      textOverflow: "ellipsis", // Add ellipsis for overflowing text
                                                    }}
                                                  >
                                                    <div
                                                    style={{
                                                      display: "flex",
                                                      justifyContent:
                                                        "space-between",
                                                      marginBottom: "4px",
                                                    }}
                                                  >
                                                    <span
                                                      style={{
                                                        fontWeight: "bold",
                                                      }}
                                                    >
                                                      {result.name}
                                                    </span>
                                                    <span>
                                                      Code:{" "}
                                                      {result.itemCode || "N/A"}
                                                    </span>
                                                  </div>
                                                  <div
                                                    style={{
                                                      display: "flex",
                                                      justifyContent:
                                                        "space-between",
                                                    }}
                                                  >
                                                    <span>
                                                      Make:{" "}
                                                      {result.make || "N/A"}
                                                    </span>
                                                    <span>
                                                      Stock:{" "}
                                                      {result.openingStock ||
                                                        "N/A"}
                                                    </span>
                                                  </div>
                                                  </li>
                                                )
                                              )}
                                            </ul>
                                          )}
                                        </div>
                                      )}
                                  </td>
                                  <Modal
                                    show={showItemModal}
                                    onHide={handleItemClose}
                                  >
                                    <div className="modal-header d-flex align-items-center pb-2 pt-2">
                                      <h5
                                        className="modal-title fs-5"
                                        id="salespersonHead"
                                      >
                                        Add Item Description
                                      </h5>
                                      <button
                                        type="button"
                                        className="btn pr-0"
                                        onClick={handleItemClose}
                                      >
                                        <ion-icon
                                          name="close-circle-outline"
                                          size="large"
                                          style={{ width: "28px" }}
                                        ></ion-icon>
                                      </button>
                                    </div>
                                    <Modal.Body>
                                      <Row>
                                        <Col md="12">
                                          <div className="row pt-2">
                                            <div className="col-lg-6">
                                              <label
                                                className="form-label"
                                                style={{
                                                  fontSize: "14px",
                                                  color: "grey",
                                                  borderRadius: "7px",
                                                }}
                                              >
                                                Item
                                              </label>
                                            </div>
                                          </div>
                                          <div className="col-lg-12 pl-0 pr-0">
                                            <input
                                              className="form-control"
                                              placeholder="Name"
                                              id="name"
                                              name="name"
                                              type="text"
                                              value={itemName}
                                              readOnly
                                            />
                                          </div>
                                        </Col>
                                      </Row>
                                      <Row>
                                        <Col md="12">
                                          <div className="row pt-2">
                                            <div className="col-lg-6">
                                              <label
                                                className="form-label"
                                                style={{
                                                  fontSize: "14px",
                                                  color: "grey",
                                                  borderRadius: "7px",
                                                }}
                                              >
                                                Description
                                              </label>
                                            </div>
                                          </div>
                                          <div className="col-lg-12 pl-0 pr-0">
                                            <textarea
                                              className="cn-textarea"
                                              type="text"
                                              placeholder="Item Description"
                                              name="description"
                                              value={itemData.description}
                                              onChange={handleItemChange}
                                              rows={2}
                                              style={{
                                                backgroundColor: "#F6F6F6",
                                                borderRadius: "9px",
                                                padding: "12px",
                                                width: "100%",
                                              }}
                                            />
                                          </div>
                                        </Col>
                                      </Row>
                                    </Modal.Body>
                                    <Modal.Footer className="p-2">
                                      <div className="modal-bottombtns">
                                        <button
                                          type="button"
                                          className="modalbtn-1 btn mt-0"
                                          onClick={handleItemClose}
                                        >
                                          Close
                                        </button>
                                        <button
                                          type="button"
                                          className="modalbtn-3 btn btn-primary"
                                          onClick={handleItem}
                                          data-bs-dismiss="modal"
                                        >
                                          Add Description
                                        </button>
                                      </div>
                                    </Modal.Footer>
                                  </Modal>
                                  {columnCheck.batchIdCheck === "YES" && (
                                    <td style={{ whiteSpace: "nowrap" }}>
                                      <input
                                        className="form-control"
                                        value={data.batchId}
                                        name="batchId"
                                        onChange={(e) =>
                                          handleInputChangess(e, i)
                                        }
                                        type="number"
                                        style={{ border: "none" }}
                                      />
                                    </td>
                                  )}
                                 <td style={{ whiteSpace: "nowrap" }}>
                                  <div style={{ position: "relative" }}>
                                    <input
                                      className="form-control noArrowNumber noBorder"
                                      value={data.itemCode || ""}
                                      name="itemCode"
                                      type="text"
                                      placeholder="Item Code"
                                      onChange={(e) =>
                                        handleItemCodeChange(e, i)
                                      }
                                      style={{ flex: 1 }}
                                    />
                                  </div>
                                  {searchPerformedItemCode &&
                                    data.itemCode &&
                                    i === searchIndexItemCode && (
                                      <div
                                        style={{
                                          position: "absolute",
                                          zIndex: 9999,
                                          top: "100%",
                                          left: 0,
                                          width: "60%", // Increased width
                                        }}
                                      >
                                        {searchResultsItemCode.length > 0 && (
                                          <ul
                                            style={{
                                              listStyleType: "none",
                                              padding: 0,
                                              position: "absolute",
                                              top: "calc(100% + 10px)",
                                              left: 0,
                                              zIndex: 1000,
                                              backgroundColor: "#FFF",
                                              boxShadow:
                                                "0px 0px 10px rgba(0, 0, 0, 0.2)",
                                              borderRadius: "5px",
                                              width: "100%",
                                              maxHeight: "300px",
                                              overflowY: "auto",
                                            }}
                                          >
                                            {searchResultsItemCode.map(
                                              (result, index) => (
                                                <li
                                                  key={index}
                                                  onClick={() =>
                                                    handleItemCodeSelect(
                                                      result.itemCode,
                                                      result.id,
                                                      i
                                                    )
                                                  }
                                                  onMouseEnter={(e) => {
                                                    e.target.style.backgroundColor =
                                                      "#408dfb";
                                                    e.target.style.color =
                                                      "#FFF";
                                                    e.target.style.borderRadius =
                                                      "5px";
                                                  }}
                                                  onMouseLeave={(e) => {
                                                    e.target.style.backgroundColor =
                                                      "";
                                                    e.target.style.color =
                                                      "#000";
                                                    e.target.style.borderRadius =
                                                      "";
                                                  }}
                                                  style={{
                                                    padding: "12px",
                                                    cursor: "pointer",
                                                    whiteSpace: "nowrap",
                                                    overflow: "hidden",
                                                    textOverflow: "ellipsis",
                                                  }}
                                                >
                                                  <div
                                                    style={{
                                                      display: "flex",
                                                      justifyContent:
                                                        "space-between",
                                                      marginBottom: "4px",
                                                    }}
                                                  >
                                                    <span
                                                      style={{
                                                        fontWeight: "bold",
                                                      }}
                                                    >
                                                      {result.name}
                                                    </span>
                                                    <span>
                                                      Code:{" "}
                                                      {result.itemCode || "N/A"}
                                                    </span>
                                                  </div>
                                                  <div
                                                    style={{
                                                      display: "flex",
                                                      justifyContent:
                                                        "space-between",
                                                    }}
                                                  >
                                                    <span>
                                                      Make:{" "}
                                                      {result.make || "N/A"}
                                                    </span>
                                                    <span>
                                                      Stock:{" "}
                                                      {result.openingStock ||
                                                        "N/A"}
                                                    </span>
                                                  </div>
                                                </li>
                                              )
                                            )}
                                          </ul>
                                        )}
                                      </div>
                                    )}
                                </td>
                                  {columnCheck.hsnCheck === "YES" && (
                                    <td style={{ whiteSpace: "nowrap" }}>
                                      <input
                                        className="form-control"
                                        value={data.hsnSac}
                                        name="hsnSac"
                                        onChange={(e) =>
                                          handleInputChangess(e, i)
                                        }
                                        type="number"
                                        style={{ border: "none" }}
                                      />
                                    </td>
                                  )}
                                  <td style={{ whiteSpace: "nowrap" }}>
                                    <select
                                      className="form-control"
                                      style={{ width: "100px", padding: "0px" }}
                                      name="account"
                                      value={data.account}
                                      onChange={(e) =>
                                        handleInputChangess(e, i)
                                      }
                                    >
                                      <option
                                        selected={true}
                                        disabled={true}
                                        value=""
                                      >
                                        Select Account
                                      </option>
                                      <option
                                        disabled="true"
                                        style={{ color: "black" }}
                                      >
                                        Other Current Assets
                                      </option>
                                      <option value="Advance Tax">
                                        Advance Tax
                                      </option>
                                      <option value="Employee Advance">
                                        Employee Advance
                                      </option>
                                      <option value="Input Tax Credits">
                                        Input Tax Credits
                                      </option>
                                      <option value="Input CGST">
                                        {" "}
                                        - Input CGST
                                      </option>
                                      <option value="Input IGST">
                                        {" "}
                                        - Input IGST
                                      </option>
                                      <option value="Input SGST">
                                        {" "}
                                        - Input SGST
                                      </option>
                                      <option value="Prepaid Expenses">
                                        Prepaid Expenses
                                      </option>
                                      <option value="Reverse Charge Tax Input but not due">
                                        Reverse Charge Tax Input but not due
                                      </option>
                                      <option value="TDS Receivable">
                                        TDS Receivable
                                      </option>
                                      <option
                                        disabled="true"
                                        style={{ color: "black" }}
                                      >
                                        Fixed Assets
                                      </option>
                                      <option value="Furniture and Equipment">
                                        Furniture and Equipment
                                      </option>
                                      <option
                                        disabled="true"
                                        style={{ color: "black" }}
                                      >
                                        Other Current Liability
                                      </option>
                                      <option value="Employee Reimbursements">
                                        Employee Reimbursements
                                      </option>
                                      <option value="GST Payable">
                                        GST Payable
                                      </option>
                                      <option value="Output CGST">
                                        {" "}
                                        - Output CGST
                                      </option>
                                      <option value="Output IGST">
                                        {" "}
                                        - Output IGST
                                      </option>
                                      <option value="Output SGST">
                                        {" "}
                                        - Output SGST
                                      </option>
                                      <option value="Opening Balance Adjustments">
                                        Opening Balance Adjustments
                                      </option>
                                      <option value="Tax Payable">
                                        Tax Payable
                                      </option>
                                      <option value="TDS Payable">
                                        TDS Payable
                                      </option>
                                      <option value="Unearned Revenue">
                                        Unearned Revenue
                                      </option>
                                      <option
                                        disabled="true"
                                        style={{ color: "black" }}
                                      >
                                        Expense
                                      </option>
                                      <option value="Advertising And Marketing">
                                        Advertising And Marketing
                                      </option>
                                      <option value="Automobile Expense">
                                        Automobile Expense
                                      </option>
                                      <option value="Bad Debt">Bad Debt</option>
                                      <option value="Bank Fees and Charges">
                                        Bank Fees and Charges
                                      </option>
                                      <option value="Consultant Expense">
                                        Consultant Expense
                                      </option>
                                      <option value="Contract Assets">
                                        Contract Assets
                                      </option>
                                      <option value="Credit Card Charges">
                                        Credit Card Charges
                                      </option>
                                      <option value="Depreciation And Amortisation">
                                        Depreciation And Amortisation
                                      </option>
                                      <option value="Depreciation Expense">
                                        Depreciation Expense
                                      </option>
                                      <option value="IT and Internet Expenses">
                                        IT and Internet Expenses
                                      </option>
                                      <option value="Janitorial Expense">
                                        Janitorial Expense
                                      </option>
                                      <option value="Lodging">Lodging</option>
                                      <option value="Meals and Entertainment">
                                        Meals and Entertainment
                                      </option>
                                      <option value="Merchandise">
                                        Merchandise
                                      </option>
                                      <option value="Office Supplies">
                                        Office Supplies
                                      </option>
                                      <option value="Other Expenses">
                                        Other Expenses
                                      </option>
                                      <option value="Postage">Postage</option>
                                      <option value="Printing and Stationery">
                                        Printing and Stationery
                                      </option>
                                      <option value="Raw Materials And Consumables">
                                        Raw Materials And Consumables
                                      </option>
                                      <option value="Rent Expense">
                                        Rent Expense
                                      </option>
                                      <option value="Repairs and Maintenance">
                                        Repairs and Maintenance
                                      </option>
                                      <option value="Salaries and Employee Wages">
                                        Salaries and Employee Wages
                                      </option>
                                      <option value="Telephone Expense">
                                        Telephone Expense
                                      </option>
                                      <option value="Transportation Expense">
                                        Transportation Expense
                                      </option>
                                      <option value="Travel Expense">
                                        Travel Expense
                                      </option>
                                      <option value="Uncategorized">
                                        Uncategorized
                                      </option>
                                      <option
                                        value=""
                                        disabled=""
                                        style={{ color: "black" }}
                                      >
                                        Cost Of Good Sold
                                      </option>
                                      <option value="Cost of Goods Sold">
                                        Cost of Goods Sold
                                      </option>
                                      <option value="Job Costing">
                                        Job Costing
                                      </option>
                                      <option value="Labor">Labor</option>
                                      <option value="Materials">
                                        Materials
                                      </option>
                                      <option value="Subcontractor">
                                        Subcontractor
                                      </option>
                                    </select>
                                  </td>
                                  {columnCheck.sizeCheck === "YES" && (
                                    <td style={{ whiteSpace: "nowrap" }}>
                                      <input
                                        className="form-control noArrowNumber noBorder"
                                        value={data.size || ""}
                                        type="number"
                                        name="size"
                                        onChange={(e) =>
                                          handleInputChangess(e, i)
                                        }
                                      />
                                    </td>
                                  )}
                                   <td style={{ whiteSpace: "nowrap" }}>
                                    <input
                                      className="form-control"
                                      value={data.per}
                                      name="per"
                                      onChange={(e) =>
                                        handleInputChangess(e, i)
                                      }
                                      type="number"
                                      style={{ border: "none" }}
                                    />
                                  </td>
                                  {columnCheck.quantityCheck === "YES" && (
                                  <td style={{ whiteSpace: "nowrap" }}>
                                    <input
                                      className="form-control"
                                      value={data.quantity}
                                      name="quantity"
                                      onChange={(e) =>
                                        handleInputChangess(e, i)
                                      }
                                      type="number"
                                      style={{ border: "none" }}
                                    />
                                  </td>
                                  )}
                                  {columnCheck.netRateCheck === "YES" && (
                                  <td style={{ whiteSpace: "nowrap" }}>
                                    <input
                                      className="form-control"
                                      type="number"
                                      name="rate1"
                                      value={data.rate1}
                                      onChange={(e) =>
                                        handleInputChangess(e, i)
                                      }
                                      style={{ border: "none" }}
                                    />
                                  </td>
                                  )}
                                  <td style={{ whiteSpace: "nowrap" }}>
                                    <input
                                      className="form-control"
                                      type="number"
                                      name="rate"
                                      value={data.rate}
                                      onChange={(e) =>
                                        handleInputChangess(e, i)
                                      }
                                      style={{ border: "none" }}
                                    />
                                  </td>
                                  {columnCheck.discountCheck === "YES" && (
                                    <td style={{ whiteSpace: "nowrap" }}>
                                      <div className="d-flex justify-content-center">
                                        <input
                                          className="form-control col-md-6 noBorder"
                                          value={data.discount || ""}
                                          type="number"
                                          onChange={(e) =>
                                            handleInputChangess(e, i)
                                          }
                                          name="discount"
                                          style={{
                                            textAlign: "center",
                                            padding: "0px",
                                            marginRight: "5px",
                                          }}
                                        />
                                        <select
                                          className="border-0 noBorder"
                                          value={data.discountType}
                                          onChange={(e) =>
                                            handleInputChangess(e, i)
                                          }
                                          name="discountType"
                                        >
                                          <option value="₹">₹</option>
                                          <option value="%">%</option>
                                        </select>
                                      </div>
                                    </td>
                                  )}

                                  {bussinessRegistered === "YES" && (
                                    <td style={{ whiteSpace: "nowrap" }}>
                                      <select
                                        className="form-control col-md-18"
                                        name="tax"
                                        value={data.tax}
                                        onChange={(e) => handleTaxChange(e, i)}
                                        style={{ padding: "0px" }}
                                      >
                                        <option value="0">N/A</option>
                                        <option value="0">0 GST [0%]</option>
                                        <option value="5">5 GST [5%]</option>
                                        <option value="12">12 GST [12%]</option>
                                        <option value="18">18 GST [18%]</option>
                                        <option value="28">28 GST [28%]</option>
                                      </select>
                                    </td>
                                  )}
                                  <td style={{ whiteSpace: "nowrap" }}>
                                    <span>
                                      {parseFloat(totalAmountWithTax).toFixed(
                                        2
                                      )}
                                    </span>
                                  </td>

                                  <td style={{ whiteSpace: "nowrap" }}>
                                    <button
                                      className="btn px-2 btn-light icon-border btn-sm"
                                      onClick={() =>
                                        handleDeleteRow(i, data.id)
                                      }
                                    >
                                      <i className="fa fa-trash text-danger"></i>
                                    </button>
                                  </td>
                                </tr>
                              </tbody>
                            );
                          })}
                        </table>
                      </div>
                    </Card>
                  </Col>
                </Row>

                <Row>
                  <Col>
                    <button
                      className="btn addline-btn"
                      type="button"
                      onClick={handleAdd}
                    >
                      + Add Another Line
                    </button>
                  </Col>
                </Row>
              </div>
              <hr />

              <div className="grid-container">
                <div className="flex-item p-0 d-flex flex-column-reverse">
                  <div className="row pt-3">
                    <div className="col-lg-6">
                      <label
                        className="form-label"
                        style={{ fontSize: "14px", color: "grey" }}
                      >
                        Customer Notes
                      </label>
                    </div>
                    <div className="col-lg-12">
                      <textarea
                        className="cn-textarea"
                        placeholder="Customer Notes..."
                        name="customerNote"
                        value={formData.customerNote}
                        onChange={handleInputChange}
                        type="text"
                        rows={1}
                        style={{
                          backgroundColor: "#F6F6F6",
                          borderRadius: "7px",
                          padding: "12px",
                        }}
                      />
                    </div>
                  </div>
                </div>
                <div className="subtotal-box p-2">
                  <div className="flex-item pb-1">
                    <div className="row">
                      <div className="col-lg-8">
                        <label className="form-label">Sub Total</label>
                      </div>
                      <div className="col-lg-4 text-end pl-0">
                        <label className="form-label">
                          {calculateSubTotal()}
                        </label>
                      </div>
                    </div>

                    {showDiscount === "YES" && (
                      <div className="row d-flex align-items-baseline mt-1">
                        <div className="col-lg-5 pr-0">
                          <label>Discount</label>
                        </div>
                        <div className="col-lg-3 pl-0 d-flex">
                          <input
                            className="form-control"
                            value={disAllValue || "0"}
                            type="number"
                            name="discount"
                            onChange={handleDisAllValueChange}
                            style={{
                              height: "36px",
                              padding: "3px 8px",
                              backgroundColor: "#F6F6F6",
                            }}
                          />

                          <select
                            className="form-control ml-1 pl-0 rounded"
                            name="discountType"
                            value={discountType}
                            onChange={handleDiscountTypeChange}
                            style={{
                              height: "36px",
                              width: "40px",
                              padding: "3px 8px",
                              backgroundColor: "#F6F6F6",
                            }}
                          >
                            <option disabled>Select</option>
                            <option value="₹">₹</option>
                            <option value="%">%</option>
                          </select>
                        </div>
                        <div className="col-lg-4 text-end pl-0">
                          <label className="form-label textColor-red">
                            {" "}
                            {isNaN(parseFloat(disValue).toFixed(2))
                              ? "0.00"
                              : -parseFloat(disValue).toFixed(2)}
                          </label>
                        </div>
                      </div>
                    )}

                    <div className="row d-flex align-items-baseline mt-2">
                      <div className="col-lg-5 pr-0">
                        <label>Discount Account</label>
                      </div>
                      <div className="col-lg-3 pl-0 d-flex">
                        <Select
                          options={discountAccountOptions}
                          // value={selectedDiscountAccount}
                          value={discountAccountOptions.find(
                            (option) => option.value === fetchedDiscountAccount
                          )}
                          onChange={handleDiscountAccountChange}
                          placeholder="Select..."
                          styles={customStyles3}
                        />
                      </div>
                    </div>

                    <div className="row mt-2">
                      {userState.state !== customerState && (
                        <>
                          {calculateIGSTForTax().map((taxResult, index) => (
                            <React.Fragment key={index}>
                              <div className="col-lg-8">
                                <label className="form-label required">
                                  IGST ({(taxResult.taxRate * 100).toFixed(0)}%)
                                </label>
                              </div>
                              <div className="col-lg-4 text-end pl-0">
                                <label className="form-label required">
                                  {taxResult.totalIGST.toFixed(2)}
                                </label>
                              </div>
                            </React.Fragment>
                          ))}
                        </>
                      )}

                      {userState.state === customerState && (
                        <>
                          {Object.entries(calculateGroupedSGSTandCGST()).map(
                            ([taxRate, taxData], index) => (
                              <React.Fragment key={index}>
                                <div className="col-lg-8">
                                  <label className="form-label required">
                                    CGST (
                                    {((parseFloat(taxRate) * 100) / 2)
                                      .toFixed(1)
                                      .replace(/\.0$/, "")}
                                    %)
                                  </label>
                                </div>
                                <div className="col-lg-4 text-end pl-0">
                                  <label className="form-label required">
                                    {taxData.totalCGST.toFixed(2)}
                                  </label>
                                </div>
                                <div className="col-lg-8 mt-2">
                                  <label className="form-label required">
                                    SGST (
                                    {((parseFloat(taxRate) * 100) / 2)
                                      .toFixed(1)
                                      .replace(/\.0$/, "")}
                                    %)
                                  </label>
                                </div>
                                <div className="col-lg-4 text-end pl-0 mt-2">
                                  <label className="form-label required">
                                    {taxData.totalSGST.toFixed(2)}
                                  </label>
                                </div>
                              </React.Fragment>
                            )
                          )}
                        </>
                      )}
                    </div>

                    <div className="my-4 d-flex justify-content-between">
                      <div
                        className="d-flex justify-content-between"
                        style={{ width: "70%" }}
                      >
                        <div className="col-lg-7 pl-0">
                          <label className="rdiobox">
                            <input
                              className="mx-1"
                              type="radio"
                              name="cus_type"
                              id="cus_bus"
                              value="TDS"
                              checked={formData.type === "TDS"}
                              onChange={() => handleRadioClick("TDS")}
                            />
                            <span>TDS</span>
                          </label>
                          <label className="rdiobox ml-3">
                            <input
                              className="mx-1"
                              type="radio"
                              name="cus_type"
                              id="cus_indivi"
                              value="TCS"
                              checked={formData.type === "TCS"}
                              onChange={() => handleRadioClick("TCS")}
                            />
                            <span>TCS</span>
                          </label>
                        </div>
                        <div
                          className="col-lg-6 p-0"
                          style={{ width: "190px" }}
                        >
                          {(showing1 || formData.type === "TDS") && (
                            <Select
                              options={tds}
                              value={selectedTdsOption}
                              onChange={handleTdsOptionChange}
                              placeholder="Select TDS..."
                              styles={customStyles3}
                            />
                          )}

                          {(showing2 || formData.type === "TCS") && (
                            <Select
                              options={tcs}
                              value={selectedTcsOption}
                              onChange={handleTcsOptionChange}
                              placeholder="Select TCS..."
                              styles={customStyles3}
                            />
                          )}
                        </div>
                      </div>
                      {(showing1 || formData.type === "TDS") && (
                        <label className="form-label">
                          {discountAmountTds}
                        </label>
                      )}

                      {(showing2 || formData.type === "TCS") && (
                        <label className="form-label">
                          {discountAmountTcs}
                        </label>
                      )}
                    </div>

                    <div className="row mt-3 mb-3">
                      <div className="col-lg-5 pr-0">
                        <input
                          className="form-control col-md-10"
                          type="text"
                          placeholder="Adjustment Label" // Provide a placeholder for user input
                          value={formData.adjustmentLabel}
                          onChange={handleInputChange}
                          name="adjustmentLabel"
                          style={{
                            backgroundColor: "#F6F6F6",
                            borderRadius: "7px",
                            color: "black",
                            "::placeholder": {
                              color:
                                "var(--Black-light-text, rgba(0, 0, 0, 0.25))",
                            },
                          }}
                        />
                      </div>
                      <div className="col-lg-5 pl-0">
                        <input
                          className="form-control col-md-10"
                          type="text"
                          onChange={handleInputChange}
                          value={formData.adjustment}
                          name="adjustment"
                          placeholder="Adjustment Value" // Provide a placeholder for user input
                          style={{
                            backgroundColor: "#F6F6F6",
                            borderRadius: "7px",
                            color: "black",
                            "::placeholder": {
                              color:
                                "var(--Black-light-text, rgba(0, 0, 0, 0.25))",
                            },
                          }}
                        />
                      </div>
                      <div className="col-lg-2 text-end pl-0">
                        <label className="form-label">
                          {formData.adjustment || oppositeValue}
                        </label>
                      </div>
                    </div>
                    <hr className="mt-0" />

                    <div className="row mt-3">
                      <div className="col-lg-8">
                        <label className="form-label required ">
                          Total (₹) :
                        </label>
                      </div>
                      <div className="col-lg-4 text-end pl-0">
                        <label className="form-label required">
                          {/* {showing2 ? calculateTotal() : calculateTotal2()} */}
                          {total}
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <hr />

              <div className="row pt-2 align-items-center">
                <div className="col-lg-6">
                  <label
                    className="form-label"
                    style={{ fontSize: "14px", color: "grey" }}
                  >
                    Terms & Condition
                  </label>
                </div>
                <div className="col-lg-12">
                  <ReactQuill
                    value={formData.termsAndCondition}
                    onChange={handleTermsAndConditionChange} // Function to update state
                    theme="snow" // Use "bubble" for a minimal UI
                    style={{ height: "300px", marginBottom: "50px" }}
                    modules={{
                      toolbar: [
                        [{ header: [1, 2, 3, 4, 5, 6, false] }], // Headers
                        [{ font: [] }], // Font options
                        [{ size: [] }], // Font size
                        [{ color: [] }, { background: [] }], // Text color & background
                        ["bold", "italic", "underline", "strike"], // Basic text styles
                        [{ script: "sub" }, { script: "super" }], // Subscript & superscript
                        [{ align: [] }], // Text alignment
                        [{ list: "ordered" }, { list: "bullet" }], // Lists
                        [{ indent: "-1" }, { indent: "+1" }], // Indentation
                        ["blockquote", "code-block"], // Blockquote & code block
                        ["link", "image", "video"], // Media links
                        ["clean"], // Remove formatting
                      ],
                    }}
                    formats={[
                      "header",
                      "font",
                      "size",
                      "color",
                      "background",
                      "bold",
                      "italic",
                      "underline",
                      "strike",
                      "script",
                      "align",
                      "list",
                      "bullet",
                      "indent",
                      "blockquote",
                      "code-block",
                      "link",
                      "image",
                      "video",
                    ]}
                  />

                  <i className="text-muted">
                    This Terms and Condition will be displayed on the bill
                  </i>
                </div>
              </div>
            </div>
          </>
        </div>

        <div className="text-right cn-bottom-buttons">
          <button className="btn-1 btn mt-0" onClick={handleCancleClick}>
            Cancel
          </button>
          {props.fetchedStatus === "Draft" && (
            <button
              className="btn-1 btn mt-0"
              onClick={insertDataIntoDatabaseAsDraft}
            >
              {isLoading2 ? "Updating..." : "Save As Draft"}
            </button>
          )}
          <button
            className="btn-3 btn btn-primary"
            onClick={insertDataIntoDatabase}
          >
            {isLoading ? "Updating..." : "Update Bill"}
          </button>
        </div>
      </div>
    </div>
  );
}

export default BillsUpdate;
